webpackJsonp([1],Array(29).concat([
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Services__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Services___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Services__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_services_Hydro__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_services_Hydro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_services_Hydro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_services_Trees__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_services_Trees___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_services_Trees__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_services_Rows__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_services_Rows___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_services_Rows__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_services_Landscape__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_services_Landscape___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_services_Landscape__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_services_Irrigation__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_services_Irrigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_services_Irrigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_services_Hydroaxe__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_services_Hydroaxe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_services_Hydroaxe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Portfolio__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Portfolio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Portfolio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Calculator__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Calculator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Calculator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_HydroCalculator__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_HydroCalculator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_HydroCalculator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Contact__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Contact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_404__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_404___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_404__);
















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    linkActiveClass: 'is-active',
    routes: [{ path: '/', name: 'home', component: __WEBPACK_IMPORTED_MODULE_2__components_Home___default.a }, {
        path: '/services', name: 'services', component: __WEBPACK_IMPORTED_MODULE_3__components_Services___default.a, children: [{ path: 'erosion-control', name: 'erosion', component: __WEBPACK_IMPORTED_MODULE_4__components_services_Hydro___default.a }, { path: 'tree-relocation', name: 'trees', component: __WEBPACK_IMPORTED_MODULE_5__components_services_Trees___default.a }, { path: 'row-maintenance', name: 'rows', component: __WEBPACK_IMPORTED_MODULE_6__components_services_Rows___default.a }, { path: 'landscaping', name: 'landscape', component: __WEBPACK_IMPORTED_MODULE_7__components_services_Landscape___default.a }, { path: 'irrigation', name: 'irrigation', component: __WEBPACK_IMPORTED_MODULE_8__components_services_Irrigation___default.a }, { path: 'hydro-axing', name: 'hydroaxe', component: __WEBPACK_IMPORTED_MODULE_9__components_services_Hydroaxe___default.a }]
    }, { path: '/estimator', name: 'calculator', component: __WEBPACK_IMPORTED_MODULE_11__components_Calculator___default.a }, { path: '/hydro', name: 'hydrocalc', component: __WEBPACK_IMPORTED_MODULE_12__components_HydroCalculator___default.a }, { path: '/portfolio', name: 'portfolio', component: __WEBPACK_IMPORTED_MODULE_10__components_Portfolio___default.a }, { path: '/contact', name: 'contact', component: __WEBPACK_IMPORTED_MODULE_13__components_Contact___default.a }, { path: '/*', name: '404', component: __WEBPACK_IMPORTED_MODULE_14__components_404___default.a }],
    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {
                selector: to.hash
            };
        }
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    }
}));

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(55),
  /* template */
  __webpack_require__(158),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(69),
  /* template */
  __webpack_require__(155),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(105)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(70),
  /* template */
  __webpack_require__(154),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(166),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(72),
  /* template */
  __webpack_require__(162),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      navOpen: false,
      affix: false
    };
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.handleAffix, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.handleAffix, { passive: true });
  },

  methods: {
    handleAffix: function handleAffix() {
      var bounds = this.$refs.footnav.getBoundingClientRect();
      this.affix = bounds.top < 52;
    }
  }
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'FourOhFour'
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'calculators',
    data: function data() {
        var _ref;

        return _ref = {
            precision: 1000,
            selectedArea: 'rectangle',
            selectedMaterial: 'mulch',
            selectedResultVolumeType: 'yards'
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'selectedResultVolumeType', 'yard'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'areas', {
            rectangle: {
                name: 'Rectangle',
                dimensions: ['length', 'width', 'depth']
            },
            rectangleborder: {
                name: 'Rectangle Border',
                dimensions: ['innerlength', 'innerwidth', 'borderwidth', 'depth']
            },
            circle: {
                name: 'Circle',
                dimensions: ['diameter', 'depth']
            },
            circleborder: {
                name: 'Circle Border',
                dimensions: ['innerdiameter', 'borderwidth', 'depth']
            },
            triangle: {
                name: 'Triangle',
                dimensions: ['side1', 'side2', 'side3', 'depth']
            }
        }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'dimensions', {
            side1: {
                name: 'Side a Length',
                unit: 'foot',
                value: 1
            },
            side2: {
                name: 'Side b Length',
                unit: 'foot',
                value: 1
            },
            side3: {
                name: 'Side c Length',
                unit: 'foot',
                value: 1
            },
            length: {
                name: 'Length',
                unit: 'foot',
                value: 1
            },
            width: {
                name: 'Width',
                unit: 'foot',
                value: 1
            },
            innerlength: {
                name: 'Inner Length',
                unit: 'foot',
                value: 1
            },
            innerwidth: {
                name: 'Inner Width',
                unit: 'foot',
                value: 1
            },
            diameter: {
                name: 'Diameter',
                unit: 'foot',
                value: 1
            },
            innerdiameter: {
                name: 'Inner Diameter',
                unit: 'foot',
                value: 1
            },
            borderwidth: {
                name: 'Border Width',
                unit: 'foot',
                value: 1
            },
            depth: {
                name: 'Material Depth',
                unit: 'inch',
                value: 1
            }
        }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'units', {
            inch: {
                name: 'Inches',
                unit: 1
            },
            foot: {
                name: 'Feet',
                unit: 12
            },
            yard: {
                name: 'Yards',
                unit: 36
            }
        }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'materials', {
            mulch: {
                name: 'Mulch',
                poundsPerYard: 700,
                volumeUnit: 'feet',
                weightUnit: 'tons'
            },
            gravel: {
                name: 'Gravel',
                poundsPerYard: 2500,
                volumeUnit: 'yards',
                weightUnit: 'tons'
            },
            granite: {
                name: 'Decomposed Granite',
                poundsPerYard: 2600,
                volumeUnit: 'yards',
                weightUnit: 'tons'
            },
            soil: {
                name: 'Soil',
                poundsPerYard: 1500,
                volumeUnit: 'yards',
                weightUnit: 'tons'
            },
            sand: {
                name: 'Sand',
                poundsPerYard: 2800,
                volumeUnit: 'yards',
                weightUnit: 'tons'
            }
        }), _ref;
    },

    computed: {
        areaShape: function areaShape() {
            return this.areas[this.selectedArea];
        },
        areaDimensions: function areaDimensions() {
            var desiredDimensions = this.areas[this.selectedArea].dimensions;
            var dimensions = {};
            for (var newDimension in desiredDimensions) {
                dimensions[desiredDimensions[newDimension]] = this.dimensions[desiredDimensions[newDimension]];
            }
            return dimensions;
        },
        results: function results() {
            var area = 0;
            if (this.selectedArea === 'rectangle') {
                var width = this.dimensions.width.value * this.units[this.dimensions.width.unit].unit;
                var length = this.dimensions.length.value * this.units[this.dimensions.length.unit].unit;
                area = width * length;
            } else if (this.selectedArea === 'triangle') {
                var side1 = this.dimensions.side1.value * this.units[this.dimensions.side1.unit].unit;
                var side2 = this.dimensions.side2.value * this.units[this.dimensions.side2.unit].unit;
                var side3 = this.dimensions.side3.value * this.units[this.dimensions.side3.unit].unit;
                area = 0.25 * Math.sqrt(Math.max(side1 + side2 + side3, 0) * Math.max(side2 + side3 - side1, 0) * Math.max(side3 + side1 - side2, 0) * Math.max(side1 + side2 - side3, 0));
            } else if (this.selectedArea === 'circle') {
                var diameter = this.dimensions.diameter.value * this.units[this.dimensions.diameter.unit].unit;
                area = Math.PI * Math.pow(diameter / 2, 2);
            } else if (this.selectedArea === 'circleborder') {
                var innerDiameter = this.dimensions.innerdiameter.value * this.units[this.dimensions.innerdiameter.unit].unit;
                var outerDiameter = innerDiameter + 2 * (this.dimensions.borderwidth.value * this.units[this.dimensions.borderwidth.unit].unit);
                var outerArea = Math.PI * Math.pow(outerDiameter / 2, 2);
                var innerArea = Math.PI * Math.pow(innerDiameter / 2, 2);
                area = outerArea - innerArea;
            } else if (this.selectedArea === 'rectangleborder') {
                var _width = this.dimensions.innerwidth.value * this.units[this.dimensions.innerwidth.unit].unit;
                var _length = this.dimensions.innerlength.value * this.units[this.dimensions.innerlength.unit].unit;
                var borderwidth = this.dimensions.borderwidth.value * this.units[this.dimensions.borderwidth.unit].unit;
                var _innerArea = _width * _length;
                var _outerArea = (_width + borderwidth * 2) * (_length + borderwidth * 2);
                area = _outerArea - _innerArea;
            }
            var depth = this.dimensions.depth.value * this.units[this.dimensions.depth.unit].unit;
            var volume = area * depth;
            var cubicInches = volume;
            var cubicFeet = volume / 1728;
            var cubicYards = cubicFeet / 27;
            return {
                area: area,
                volume: volume,
                feet: Math.round(cubicFeet * this.precision) / this.precision,
                yards: Math.round(cubicYards * this.precision) / this.precision
            };
        }
    }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_forms__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_forms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_forms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_forms_lib_validators__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_forms_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_forms_lib_validators__);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'contact',
    data: function data() {
        return {
            form: new __WEBPACK_IMPORTED_MODULE_2_vuex_forms__["Form"](this, {
                name: null,
                email: null,
                subject: null,
                message: null
            }, {
                validations: {
                    name: { required: __WEBPACK_IMPORTED_MODULE_3_vuex_forms_lib_validators__["required"] },
                    email: { required: __WEBPACK_IMPORTED_MODULE_3_vuex_forms_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_3_vuex_forms_lib_validators__["email"] },
                    subject: { required: __WEBPACK_IMPORTED_MODULE_3_vuex_forms_lib_validators__["required"], maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex_forms_lib_validators__["maxLength"])(100) },
                    message: { required: __WEBPACK_IMPORTED_MODULE_3_vuex_forms_lib_validators__["required"], maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex_forms_lib_validators__["maxLength"])(800) }
                },
                inputDebounce: 500
            }),
            sent: false,
            sending: false
        };
    },

    methods: {
        submitForm: function submitForm() {
            var _this = this;

            this.form.$v.$touch();
            var errors = this.form.validate();
            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(errors).length > 0) return false;
            this.sending = true;

            setTimeout(function () {
                var data = _this.form.data();
                return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
                    method: 'post',
                    url: '/api/send',
                    data: data
                }).then(function (data) {
                    _this.form.reset();
                    _this.form.name = null;
                    _this.form.email = null;
                    _this.form.subject = null;
                    _this.form.message = null;
                    _this.sent = true;
                    _this.sending = false;
                }).catch(function (error) {
                    var errors = error.response.data;
                    _this.form.errors.clear();
                    _this.form.errors.record(errors);
                    _this.sending = false;
                });
            }, 500);
        }
    }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'home',
    data: function data() {
        return {};
    }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'hydro-calculator',
    data: function data() {
        return {
            precision: 1000,
            selectedProjectSizeUnit: 'acre',
            totalProjectSize: 1,
            tankWorkingCapacity: 500,
            projectSizeUnits: {
                square_feet: {
                    name: 'Square Feet',
                    sqft: 1
                },
                square_yard: {
                    name: 'Square Yards',
                    sqft: 9
                },
                acre: {
                    name: 'Acres',
                    sqft: 43560
                },
                hectare: {
                    name: 'Hectares',
                    sqft: 107639
                }
            },
            mulchApplicationRate: 2000,
            mulchMixRate: 50,
            mulchBagWeight: 50,
            seeds: [],
            seedTemplate: {
                name: 'Generic Seed',
                applicationRate: 90,
                mixRate: 2.3,
                bagWeight: 50 }
        };
    },

    methods: {
        addSeed: function addSeed() {
            this.seeds.push(this.seedTemplate);
        },
        removeSeed: function removeSeed(index) {
            this.seeds.splice(index, 1);
        }
    },
    computed: {
        projectSizeUnit: function projectSizeUnit() {
            return this.projectSizeUnits[this.selectedProjectSizeUnit];
        },
        results: function results() {
            var area = Math.round(this.totalProjectSize * this.projectSizeUnit.sqft * this.precision) / this.precision;

            return {
                area: area
            };
        }
    }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'portfolio',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Services'
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'erosion',
    mounted: function mounted() {
        window.addEventListener('scroll', this.handleScroll, false);
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll, false);
    },
    data: function data() {
        return {
            affixed: false
        };
    },

    methods: {
        handleScroll: function handleScroll() {
            var bounds = this.$refs.subnav.getBoundingClientRect();
            this.affixed = bounds.top < 101;
        }
    }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'hydroaxe',
    data: function data() {
        return {};
    }
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'irrigation',
    mounted: function mounted() {
        window.addEventListener('scroll', this.handleScroll, false);
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll, false);
    },
    data: function data() {
        return {
            affixed: false
        };
    },

    methods: {
        handleScroll: function handleScroll() {
            var bounds = this.$refs.subnav.getBoundingClientRect();
            this.affixed = bounds.top < 101;
        }
    }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'landscape',
    data: function data() {
        return {};
    }
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'rows',
    data: function data() {
        return {};
    }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'trees',
    mounted: function mounted() {
        window.addEventListener('scroll', this.handleScroll, false);
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll, false);
    },
    data: function data() {
        return {
            affixed: false
        };
    },

    methods: {
        handleScroll: function handleScroll() {
            var bounds = this.$refs.subnav.getBoundingClientRect();
            this.affixed = bounds.top < 117;
        }
    }
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Affix',
    props: ['defaultTrigger'],
    data: function data() {
        return {
            showScrollToTop: false,
            showAffix: false,
            affixOffset: 0,
            triggers: [],
            activeTrigger: '',
            scrollTolerance: 100,
            scrollTimeout: 50,
            scrollTimedOut: false
        };
    },
    mounted: function mounted() {
        this.activeTrigger = this.defaultTrigger;
        this.triggers = this.$el.querySelectorAll('.affix-trigger');
        this.onScroll();
        window.addEventListener('scroll', this.onScroll, { passive: true });
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('scroll', this.onScroll, { passive: true });
    },

    methods: {
        onScroll: function onScroll() {
            var scrollBounds = this.$slots.content[0].elm.getBoundingClientRect();
            this.showScrollToTop = scrollBounds.top < 0;
            this.showAffix = this.showScrollToTop;
            this.affixOffset = scrollBounds.bottom < 360 ? Math.abs(scrollBounds.bottom - 360) : 0;

            if (this.scrollTimedOut) return;
            var tops = [];
            Array.prototype.forEach.call(this.triggers, function (trigger) {
                tops.push({
                    top: trigger.getBoundingClientRect().top,
                    name: trigger.getAttribute('name')
                });
            });

            if (window.scrollY < scrollBounds.top) {
                this.activeTrigger = tops[0].name;
                this.timeoutScroll();
                return;
            }

            var activeTrigger = tops[0].name;
            for (var i = 0; i < tops.length; i++) {
                var trigger = tops[i];
                var previousTrigger = tops[i - 1];
                var nextTrigger = tops[i + 1];
                if (nextTrigger && previousTrigger) {
                    if (trigger.top < this.scrollTolerance && nextTrigger.top > this.scrollTolerance && previousTrigger.top < trigger.top && nextTrigger.top > trigger.top) {
                        activeTrigger = trigger.name;
                        break;
                    }
                } else if (nextTrigger && trigger.top < this.scrollTolerance && nextTrigger.top > this.scrollTolerance && trigger.top < nextTrigger.top) {
                    activeTrigger = trigger.name;
                    break;
                } else if (previousTrigger && trigger.top < this.scrollTolerance && trigger.top > previousTrigger.top) {
                    activeTrigger = trigger.name;
                    break;
                }
            }

            this.activeTrigger = activeTrigger;
            this.timeoutScroll();
        },
        timeoutScroll: function timeoutScroll() {
            this.scrollTimedOut = true;
            setTimeout(function () {
                this.scrollTimedOut = false;
            }.bind(this), this.scrollTimeout);
        },
        scrollToTop: function scrollToTop() {
            this.$slots.content[0].elm.scrollIntoView();
        }
    }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'portfolio-item',
  props: ['src', 'caption']
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'SvgRenderer',
    props: ['file']
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex_forms_lib_mixins_vuex_text__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex_forms_lib_mixins_vuex_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuex_forms_lib_mixins_vuex_text__);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'TextInput',
    mixins: [__WEBPACK_IMPORTED_MODULE_0_vuex_forms_lib_mixins_vuex_text___default()()]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scss_main_scss__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scss_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__scss_main_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_analytics__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_forms__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_forms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuex_forms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_SvgRenderer_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_SvgRenderer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_shared_SvgRenderer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_Affix_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_Affix_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_shared_Affix_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_TextInput_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_TextInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_shared_TextInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_shared_PortfolioItem__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_shared_PortfolioItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_shared_PortfolioItem__);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_analytics___default.a, {
    id: 'UA-100999435-1',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vuex_forms___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('svg-renderer', __WEBPACK_IMPORTED_MODULE_6__components_shared_SvgRenderer_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('affix', __WEBPACK_IMPORTED_MODULE_7__components_shared_Affix_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('text-input', __WEBPACK_IMPORTED_MODULE_8__components_shared_TextInput_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('portfolio-item', __WEBPACK_IMPORTED_MODULE_9__components_shared_PortfolioItem___default.a);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 104 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 106 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\">\r\n    <label :for=\"id\">\r\n        <input ref=\"input\"\r\n               :id=\"id\"\r\n               :name=\"name\"\r\n               type=\"checkbox\"\r\n               :value=\"value\"\r\n               :checked=\"value === trueValue\"\r\n               :required=\"required\"\r\n               @change=\"handleCheckbox\"\r\n               class=\"form-control\">\r\n        {{ label }}\r\n    </label>\r\n    <ul class=\"form-errors\" v-if=\"fieldErrors\">\r\n        <li v-for=\"error in fieldErrors\">{{ error }}</li>\r\n    </ul>\r\n</div>";

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\">\r\n    <label v-html=\"label\"></label>\r\n    <label v-for=\"option in options\" :for=\"(id || name) + option[option_name]\">\r\n        <input type=\"radio\"\r\n               :name=\"name\"\r\n               :id=\"(id || name) + option[option_name]\"\r\n               :value=\"option[option_value]\"\r\n               :checked=\"value === option[option_value]\"\r\n               @change=\"handleRadio\"\r\n               class=\"form-control\">\r\n        {{ option[option_name] }}\r\n    </label>\r\n    <ul class=\"form-errors\" v-if=\"fieldErrors\">\r\n        <li v-for=\"error in fieldErrors\">{{ error }}</li>\r\n    </ul>\r\n</div>";

/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\">\r\n    <label v-if=\"label\" :for=\"id\" v-html=\"label\"></label>\r\n\r\n    <select :id=\"id\"\r\n            :name=\"name\"\r\n            :value=\"value\"\r\n            :multiple=\"multiple\"\r\n            :disabled=\"disabled\"\r\n            :required=\"required\"\r\n            @change=\"handleInput\"\r\n            @blur=\"handleBlur\"\r\n            @focus=\"handleFocus\"\r\n            class=\"form-control\">\r\n        <option v-for=\"option in options\" :value=\"option[option_value]\" v-text=\"option[option_name]\"></option>\r\n    </select>\r\n    <ul class=\"form-errors\" v-if=\"fieldErrors\">\r\n        <li v-for=\"error in fieldErrors\">{{ error }}</li>\r\n    </ul>\r\n</div>";

/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\">\r\n    <label v-if=\"label\" :for=\"id\" v-html=\"label\"></label>\r\n\r\n    <textarea v-if=\"type === 'textarea'\"\r\n              ref=\"input\"\r\n              :id=\"id\"\r\n              :name=\"name\"\r\n              v-model=\"tempValue\"\r\n              :placeholder=\"placeholder\"\r\n              :required=\"required\"\r\n              @input=\"handleInput\"\r\n              @keydown=\"handleKeyDown\"\r\n              @blur=\"handleBlur\"\r\n              @focus=\"handleFocus\"\r\n              class=\"form-control\"></textarea>\r\n\r\n    <input v-if=\"type !== 'textarea'\"\r\n           ref=\"input\"\r\n           :id=\"id\"\r\n           :name=\"name\"\r\n           :type=\"type\"\r\n           :value=\"tempValue\"\r\n           :placeholder=\"placeholder\"\r\n           :required=\"required\"\r\n           :disabled=\"disabled\"\r\n           @input=\"handleInput\"\r\n           @keydown=\"handleKeyDown\"\r\n           @blur=\"handleBlur\"\r\n           @focus=\"handleFocus\"\r\n           class=\"form-control\">\r\n    <ul class=\"form-errors\" v-if=\"fieldErrors\">\r\n        <li v-for=\"error in fieldErrors\">{{ error }}</li>\r\n    </ul>\r\n</div>";

/***/ }),
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "80c635d8b0dcf1e44a0f8a7f0cc86ad7.jpg";

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7e62d0fc069d08397fdd4d3eba4476f9.jpg";

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "06a782bd80f122b2ac9d6a9d89499c01.jpg";

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d704d9cd667f6e7c6785f6301563c6bc.jpg";

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bb0cfc5319528c6a6366627037e95e74.jpg";

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "76b178293f88c4730cfed6b2a42e84a2.png";

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3e458b20daa1cb59e338877c64f94cc0.jpg";

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2b7d14270f1c81190d429a26fc18a6d9.jpg";

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "74d21fb1b3559bb8ce35235c9d72010d.jpg";

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a8114d25f7af1de88a96763a3d31c67a.jpg";

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "91f5853bc8c208443f67414e94fad6df.jpg";

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "23f614f8373bfdaae77e85a017fecf49.jpg";

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a673bc099425fd37b926cfb825f26c5c.jpg";

/***/ }),
/* 128 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c8b2ff4a30a2d657ea127f0f4c253019.svg";

/***/ }),
/* 131 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d0f388a1c894247f3de21eb704c08d4b.svg";

/***/ }),
/* 133 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bc573972c7a19045c5df79e91683e255.svg";

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "54554477cf75c83244267c52906d9005.svg";

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(106)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(156),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(57),
  /* template */
  __webpack_require__(163),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(103)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(58),
  /* template */
  __webpack_require__(151),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(150),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(60),
  /* template */
  __webpack_require__(160),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(104)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(61),
  /* template */
  __webpack_require__(152),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(153),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(63),
  /* template */
  __webpack_require__(164),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(64),
  /* template */
  __webpack_require__(149),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(165),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(66),
  /* template */
  __webpack_require__(157),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(67),
  /* template */
  __webpack_require__(159),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(161),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "service-title title is-1"
  }, [_vm._v("Hydro-axing")]), _vm._v(" "), _c('div', {
    staticClass: "service-content no-nav content"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8"
  }, [_c('p', [_vm._v("\n                    To give the simplest definition, hydro-axing is a method of tree removal.\n                    Specifically, hydro-axing is perfect for when you have to clear a lot of trees,\n                    such as for a fence line, a walking trail or even just to thin out a patch of\n                    trees that have grown too unruly and dense.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Once the decision is made to reclaim the resources of your land, it is of primary importance\n                    that the clearing is done properly. In the past, skid loaders and large bulldozers were used\n                    to knock trees down, push them into piles, and burn them. This method creates a long list of\n                    problems for the land. Most importantly, when a tree is knocked down and its root system pulled,\n                    it exposes all the surrounding soil to the elements. With no roots intact, the first heavy rains\n                    begin to wash the majority of the soil away. With the canopy removed, the sun bakes the soil into\n                    a hard, almost concrete-like barrier and the soil temperatures rise to levels that prevent in\n                    germination of forage grass seeds. What is soon left is a landscape of small starving trees trying\n                    to grow in piles of rocks and stumps. Other problems with the dozer method include unsightly brush\n                    piles, some that have to sit for long periods of time until the summer burn bans are lifted, stumps\n                    that dot the cleared areas, and once the piles are able to be burned, large scorch marks on the burn\n                    area where nothing will grow for several seasons. Fortunately, there is a better way!\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(119)
    }
  })])]), _vm._v(" "), _c('p', [_vm._v("\n            Using specialized equipment, Gulf Coast is able to cut and shred the unwanted brush and\n            other overgrowth in place, in one step, leaving nothing behind but a protective bed of mulch.\n            The equipment acts in a very similar way to your mulching lawnmower, shredding up the vegetation\n            and returning it to the soil from which it came to begin the decomposition\n            and soil nutrient re-enriching process.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            The benefits of using our methods include:\n        ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n                Maximum soil erosion protection and stabilization with a mulch bed that shields the soil from hard rains and insulates it from the scorching summer sun.\n            ")]), _vm._v(" "), _c('li', [_vm._v("\n                Maximum soil moisture retention. The moisture will remain in the soil and thus be available for use by the desired trees and forage grasses for maximized growth. Also, once the soil is fully saturated, the water will seep deeper to refill aquifers and water tables, which feed natural springs and wells with clear, naturally filtered water.\n            ")]), _vm._v(" "), _c('li', [_vm._v("The mulch bed protects grass and tree seeds and allows for productive germination.")]), _vm._v(" "), _c('li', [_vm._v("\n                The increased water and food supply will in turn boost the health and populations of native wildlife and domestic livestock.\n            ")]), _vm._v(" "), _c('li', [_vm._v("\n                Our method is the most efficient and cost effective way to clear land with the highest benefit to both the land and the land owner.\n            ")])]), _vm._v(" "), _c('p', [_vm._v("\n            If you are ready to get the most out of your property, either from its majestic trees and rolling\n            open grasslands, from its investment value, or from its ranching utility.  Gulf Coast would be happy\n            to meet for a free consultation.\n        ")])])])
}]}

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Who we are")]), _vm._v(" "), _c('p', [_vm._v("\n            Gulf Coast has been transforming the landscape of the Rio Grande Valley of South Texas since 1995, moving\n            over 7,700 trees for the Texas Department of Transportation alone.\n            It was also the first to utilize large mechanical tree spades, allowing thousands of\n            full-sized palms and other trees to be relocated and saved, giving new highways and\n            landscapes an instant, established look.\n            It has performed a variety of other contracting services since its inception.\n            Gulf Coast presently specializes in small to medium size projects, ranging from new construction\n            landscaping and erosion control to alterations in existing exterior spaces.\n            Gulf Coast concentrates it knowledge and expertise in large tree and palm relocation,\n            erosion control, and new landscaping on commercial, state, and municipal projects,\n            including private projects.\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-9"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Our Vision")]), _vm._v(" "), _c('p', [_vm._v("\n                    The company’s vision is to protect and prevent the destruction of existing trees and foliage by\n                    successfully relocating them using mechanical tree spades. The company believes the\n                    landscape around us can be transformed to be aesthetically pleasing, without having to remove the\n                    plants from our ecosystem.\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-3 has-text-centered"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "max-width": "300px"
    },
    attrs: {
      "src": __webpack_require__(115)
    }
  })])])])])
}]}

/***/ }),
/* 151 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('transition', {
    attrs: {
      "name": "fadeInGrow",
      "mode": "out-in",
      "appear": ""
    }
  }, [(_vm.sent) ? _c('div', {
    staticClass: "message-sent"
  }, [_c('h1', {
    staticClass: "subtitle is-3"
  }, [_vm._v("\n                        Message sent successfully!\n                    ")])]) : _vm._e()]), _vm._v(" "), (!_vm.sent) ? _c('div', [_vm._m(1), _vm._v(" "), _c('text-input', {
    attrs: {
      "label": "Your name",
      "name": "name",
      "errors": _vm.form.errors.get('name')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen($event)
      }
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "label": "Your email",
      "name": "email",
      "type": "email",
      "placeholder": "you@example.com",
      "errors": _vm.form.errors.get('email')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen($event)
      }
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "label": "Subject",
      "name": "subject",
      "placeholder": "e.g. Tree relocation",
      "errors": _vm.form.errors.get('subject')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen($event)
      }
    },
    model: {
      value: (_vm.form.subject),
      callback: function($$v) {
        _vm.$set(_vm.form, "subject", $$v)
      },
      expression: "form.subject"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "label": "Message",
      "name": "message",
      "type": "textarea",
      "placeholder": "Explain what you need and provide any relevant information - include your phone number if you would like a call back.",
      "errors": _vm.form.errors.get('message')
    },
    on: {
      "event": function($event) {
        return _vm.form.listen($event)
      }
    },
    model: {
      value: (_vm.form.message),
      callback: function($$v) {
        _vm.$set(_vm.form, "message", $$v)
      },
      expression: "form.message"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "field is-grouped"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    class: {
      'button is-primary': true, 'is-loading': _vm.sending
    },
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v("\n                            Submit\n                        ")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link",
    attrs: {
      "disabled": _vm.sending
    },
    on: {
      "click": function($event) {
        return _vm.form.reset()
      }
    }
  }, [_vm._v("Cancel")])])])], 1) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-6"
  }, [_c('h1', {
    staticClass: "title is-1"
  }, [_vm._v("Contact Us")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', {
    staticClass: "subtitle is-3"
  }, [_vm._v("Gulf Coast Contractors, Inc.")]), _vm._v(" "), _c('p', [_vm._v("\n                1-877-MOV-TREE "), _c('a', {
    attrs: {
      "href": "tel:18776688733"
    }
  }, [_c('small', [_vm._v("(1-877-668-8733)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:19564126384"
    }
  }, [_vm._v("(956) 412-6384")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:info@gulfcoastrgv.com"
    }
  }, [_vm._v("info@gulfcoastrgv.com")])]), _vm._v(" "), _c('p', [_vm._v("\n                25691 Altas Palmas Rd\n                "), _c('br'), _vm._v("\n                Harlingen, TX 78552\n            ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Office Hours:")]), _vm._v(" "), _c('br'), _vm._v("\n                8AM - 5PM CDT\n                "), _c('br'), _vm._v(" Monday-Friday\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "subtitle is-4"
  }, [_vm._v("\n                    Request more information\n                    "), _c('br'), _vm._v(" "), _c('em', [_c('small', [_vm._v("Typically answered in 1 to 2 hours, or by the next business day.")])])])
}]}

/***/ }),
/* 152 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title is-1"
  }, [_vm._v("Our Portfolio")]), _vm._v(" "), _c('div', {
    staticClass: "page-section"
  }, [_c('div', {
    staticClass: "portfolio"
  }, [_c('portfolio-item', {
    attrs: {
      "src": "/assets/portfolio/mcallen_firestation.jpg"
    }
  }), _vm._v(" "), _c('portfolio-item', {
    attrs: {
      "src": "/assets/portfolio/stabilizing_ocelot_crossings_FM_106.jpg"
    }
  }), _vm._v(" "), _c('portfolio-item', {
    attrs: {
      "src": "/assets/portfolio/apartment_rehabilitation.jpg"
    }
  }), _vm._v(" "), _c('portfolio-item', {
    attrs: {
      "src": "/assets/portfolio/sci_tech_palm_transplant.jpg"
    }
  }), _vm._v(" "), _c('portfolio-item', {
    attrs: {
      "src": "/assets/portfolio/hand_palm_planting_NISSAN.jpg"
    }
  }), _vm._v(" "), _c('portfolio-item', {
    attrs: {
      "src": "/assets/portfolio/texas_persimmon.jpg"
    }
  }), _vm._v(" "), _c('portfolio-item', {
    attrs: {
      "src": "/assets/portfolio/planting_palm.jpg"
    }
  }), _vm._v(" "), _c('portfolio-item', {
    attrs: {
      "src": "/assets/portfolio/sourcing_large_palm.jpg"
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports={render:function (){
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "service-page"
  }, [(_vm.$route.name === 'services') ? _c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title is-1"
  }, [_vm._v("Our Services")]), _vm._v(" "), _c('div', {
    staticClass: "services"
  }, [_c('router-link', {
    staticClass: "service",
    attrs: {
      "to": {
        name: 'trees'
      },
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "service-bg trees"
  }), _vm._v(" "), _c('div', {
    staticClass: "service-text"
  }, [_c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Tree Relocation")]), _vm._v(" "), _c('div', {
    staticClass: "service-expand"
  }, [_c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Why a Tree Spade")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Site Considerations")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("The Process")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Post-Relocation Care")])])])])]), _vm._v(" "), _c('router-link', {
    staticClass: "service",
    attrs: {
      "to": {
        name: 'erosion'
      },
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "service-bg hydro"
  }), _vm._v(" "), _c('div', {
    staticClass: "service-text"
  }, [_c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Erosion Control")]), _vm._v(" "), _c('div', {
    staticClass: "service-expand"
  }, [_c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Hydroseeding")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Drillseeding")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Silt Fencing")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Blankets/Logs")])])])])]), _vm._v(" "), _c('router-link', {
    staticClass: "service",
    attrs: {
      "to": {
        name: 'rows'
      },
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "service-bg rows"
  }), _vm._v(" "), _c('div', {
    staticClass: "service-text"
  }, [_c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Row Maintenance")]), _vm._v(" "), _c('div', {
    staticClass: "service-expand"
  }, [_c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Litter Removal")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Roadside Mowing")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Roadside Edging & Sweeping")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Herbicide Application")])])])])]), _vm._v(" "), _c('router-link', {
    staticClass: "service",
    attrs: {
      "to": {
        name: 'landscape'
      },
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "service-bg landscape"
  }), _vm._v(" "), _c('div', {
    staticClass: "service-text"
  }, [_c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Landscaping")]), _vm._v(" "), _c('div', {
    staticClass: "service-expand"
  }, [_c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Excavation")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Planting")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Irrigation")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Hardscapes")])])])])]), _vm._v(" "), _c('router-link', {
    staticClass: "service",
    attrs: {
      "to": {
        name: 'irrigation'
      },
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "service-bg irrigation"
  }), _vm._v(" "), _c('div', {
    staticClass: "service-text"
  }, [_c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Irrigation")]), _vm._v(" "), _c('div', {
    staticClass: "service-expand"
  }, [_c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Drip Systems")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Popup Systems")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Directional Spray")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("WiFi Controllers")])])])])]), _vm._v(" "), _c('router-link', {
    staticClass: "service",
    attrs: {
      "to": {
        name: 'hydroaxe'
      },
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "service-bg hydroaxe"
  }), _vm._v(" "), _c('div', {
    staticClass: "service-text"
  }, [_c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Hydro-Axing")]), _vm._v(" "), _c('div', {
    staticClass: "service-expand"
  }, [_c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Erosion Prevention")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Soil Stabilization")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Moisture Retention")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Wildlife Protection")])])])])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.$route.name !== 'services') ? _c('div', {
    staticClass: "hero is-large"
  }, [_c('div', {
    class: ( _obj = {
      'hero-body hero-image': true
    }, _obj[_vm.$route.name] = true, _obj )
  })]) : _vm._e(), _vm._v(" "), (_vm.$route.name !== 'services') ? _c('div', {
    staticClass: "service-container"
  }, [_c('router-view')], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 154 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portfolio-item"
  }, [_c('img', {
    attrs: {
      "src": _vm.src
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("navigation", null, {
    "activeTrigger": _vm.activeTrigger
  }), _vm._v(" "), _vm._t("content")], 2)
},staticRenderFns: []}

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('transition', {
    attrs: {
      "name": "fadeInGrow",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "four-oh-four"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("404!")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', {
    staticClass: "subtitle is-1"
  }, [_vm._v("\n                Hmmm... Couldn't find that one!\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                Try going to the\n                "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("home page")]), _vm._v("\n                or use the navigation links above to find what you're looking for.\n            ")], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "service-title title is-1"
  }, [_vm._v("Landscaping")]), _vm._v(" "), _c('div', {
    staticClass: "service-content no-nav content"
  }, [_c('p', [_vm._v("\n            Gulf Coast has the capability and skilled staff to coordinate and properly install the full scope\n            of your landscape project. For years, we have given property owners, managers, builders,\n            and specialty craftspeople our professional advice on scheduling, project management,\n            and cost-effectiveness\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            No matter the client, project or property size, Gulf Coast Landscape Services builds beautiful\n            and worry-free landscapes, with a customer experience to match. Since our founding in 1995,\n            that has been and remains our driving goal.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            We partner with owners, architects and general contractors to ensure a finished product that\n            is delivered on time and on budget. We have experience with Industrial, Office, Retail,\n            Medical and Multi-Family, projects.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            We work with Developers, General Contractors, Builders, Architectural Firms and large national\n            companies from start to finish on each project. Working within specific budgets and\n            timeframes, we ensure direct supervision on every job, for services that include:\n        ")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("Our Services")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('ul', [_c('li', [_vm._v("Hardscape Installation")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'irrigation'
      }
    }
  }, [_vm._v("Irrigation Installations")])], 1), _vm._v(" "), _c('li', [_vm._v("Paver Installation")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'erosion'
      }
    }
  }, [_vm._v("Soil Erosion")])], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'trees'
      }
    }
  }, [_vm._v("Tree Relocation")])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-6"
  }, [_c('ul', [_c('li', [_vm._v("Excavating")]), _vm._v(" "), _c('li', [_vm._v("Retaining  Walls")]), _vm._v(" "), _c('li', [_vm._v("Site Work")]), _vm._v(" "), _c('li', [_vm._v("Commercial Landscaping Build")]), _vm._v(" "), _c('li', [_vm._v("Commercial Irrigation Projects")]), _vm._v(" "), _c('li', [_vm._v("Arboriculture- Tree Services")]), _vm._v(" "), _c('li', [_vm._v("Landscape Planting")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/services/erosion-control#hydroseeding"
    }
  }, [_vm._v("Hydro-seeding")])])
}]}

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(['home', 'portfolio', 'calculator', 'hydrocalc', 'contact', '404'].indexOf(_vm.$route.name) !== -1) ? _c('div', {
    staticClass: "bg"
  }) : _vm._e(), _vm._v(" "), _c('section', {
    class: {
      'hero header': true, 'is-fullheight is-fh-adj': _vm.$route.name === 'home'
    }
  }, [_c('div', {
    staticClass: "hero-head head-has-affix"
  }, [_c('header', {
    staticClass: "nav head-affix"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    staticStyle: {
      "max-height": "2.5rem"
    },
    attrs: {
      "src": __webpack_require__(129)
    }
  })]), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('span', {
    class: {
      'nav-toggle': true, 'is-active': _vm.navOpen
    },
    on: {
      "click": function($event) {
        _vm.navOpen = !_vm.navOpen
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
    class: {
      'nav-right nav-menu': true, 'is-active': _vm.navOpen
    },
    on: {
      "click": function($event) {
        _vm.navOpen = false
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'home'
      },
      "exact": ""
    }
  }, [_vm._v("Home")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'services'
      }
    }
  }, [_vm._v("Services")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'portfolio'
      }
    }
  }, [_vm._v("Portfolio")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'calculator'
      }
    }
  }, [_vm._v("Estimator")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_vm._v("Contact")])], 1)])])]), _vm._v(" "), (_vm.$route.name === 'home') ? _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "bgvid"
  }, [_c('video', {
    attrs: {
      "playsinline": "",
      "autoplay": "",
      "muted": "",
      "loop": "",
      "poster": "../assets/bgs/palmfield.jpg",
      "id": "bgvid"
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": "/assets/vid1.mp4",
      "type": "video/mp4"
    }
  })])]), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "footnav",
    class: {
      'hero-foot': true, 'foot-has-affix': _vm.affix
    }
  }, [_c('nav', {
    class: {
      'tabs is-boxed is-fullwidth': true, 'foot-affix': _vm.affix
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('ul', [_c('li', {
    class: {
      'is-active': _vm.$route.name === 'trees'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'trees'
      }
    }
  }, [_vm._v("Tree Relocation")])], 1), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.$route.name === 'erosion'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'erosion'
      }
    }
  }, [_vm._v("Erosion Control")])], 1), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.$route.name === 'rows'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'rows'
      }
    }
  }, [_vm._v("ROW Maintenance")])], 1), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.$route.name === 'landscape'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'landscape'
      }
    }
  }, [_vm._v("Landscaping")])], 1), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.$route.name === 'irrigation'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'irrigation'
      }
    }
  }, [_vm._v("Irrigation")])], 1), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.$route.name === 'hydroaxe'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'hydroaxe'
      }
    }
  }, [_vm._v("Hydro-Axing")])], 1)])])])])]), _vm._v(" "), _c('section', {
    staticClass: "main"
  }, [_c('router-view'), _vm._v(" "), _vm._m(2)], 1), _vm._v(" "), _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'services'
      }
    }
  }, [_vm._v("Services")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'portfolio'
      }
    }
  }, [_vm._v("Portfolio")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'calculator'
      }
    }
  }, [_vm._v("Estimator")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_vm._v("Contact")])], 1)]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-item nav-logos"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/assets/hub.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/assets/ieca.svg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/assets/dbe.svg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/assets/sbe.svg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container has-text-white has-text-centered"
  }, [_c('br'), _vm._v(" "), _c('img', {
    staticClass: "hero-gulf-logo",
    attrs: {
      "src": __webpack_require__(130)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header-logos"
  }, [_c('img', {
    staticClass: "hero-wide-cert",
    attrs: {
      "src": "/assets/hub-invert.png"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticClass: "hero-narrow-cert",
    attrs: {
      "src": "/assets/dbe-invert.svg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "hero-narrow-cert",
    attrs: {
      "src": "/assets/sbe-invert.svg"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticClass: "hero-wide-cert",
    attrs: {
      "src": "/assets/ieca-invert.svg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-logos"
  }, [_c('img', {
    attrs: {
      "src": "/assets/hub.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/assets/ieca.svg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/assets/dbe.svg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/assets/sbe.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-logo"
  }, [_c('img', {
    staticStyle: {
      "max-width": "150px"
    },
    attrs: {
      "src": __webpack_require__(128)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline-content"
  }, [_vm._v("\n          Gulf Coast Contractors, Inc.\n          "), _c('br'), _vm._v("\n          © 1995-2018 All Rights Reserved\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline-content"
  }, [_vm._v("\n          25691 Altas Palmas Road, Harlingen, TX 78552\n          "), _c('br'), _vm._v("\n          (956) 412-6384   1-877-MOV-TREE\n        ")])
}]}

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "service-title title is-1"
  }, [_vm._v("Right-of-way Maintenance")]), _vm._v(" "), _c('div', {
    staticClass: "service-content no-nav"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8"
  }, [_c('p', [_vm._v("\n                    Gulf Coast Contractors has been providing vegetation maintenance services to TxDot,\n                    Cities and Counties for over 20 years. Our expert staff is committed to provide high quality\n                    service to our customers while operating in a safe manner among the traveling public.\n                    As with all the services we provide, the Gulf Coast team will always provide a level of\n                    quality and accountability that is second to none.\n                ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "page-section content"
  }, [_c('dl', [_c('dt', [_vm._v("Litter Removal")]), _vm._v(" "), _c('dd', [_vm._v("\n                            Complete litter removal services within the roadway limits are provided on a routine basis, both before a cycle of mowing and on an interim basis.  All litter is bagged and removed from the roadway on the same day with disposal receipts provided upon request.\n                        ")]), _vm._v(" "), _c('dt', [_vm._v("Roadside Mowing")]), _vm._v(" "), _c('dd', [_vm._v("\n                            We maintain a  fleet of John Deere tractors with 15’  mowing decks for large machine mowing services.  We also operate several zero turn mowing crews for mowing of smaller, curbed or limited access areas.\n                        ")]), _vm._v(" "), _c('dt', [_vm._v("Roadside Edging & Sweeping")]), _vm._v(" "), _c('dd', [_vm._v("\n                            We have performed over 5000 miles of roadway edging services annually statewide.  Through both mechanical and manual means our staff will provide your roadways with the finished, manicured look only proper edging of grass can provide.  Our unique ability to provide a street sweeper along with the operation leaves the entire site looking clean and complete each day.\n                        ")]), _vm._v(" "), _c('dt', [_vm._v("Herbicide Application")]), _vm._v(" "), _c('dd', [_vm._v("\n                            Our fully licensed herbicide team will provide the proper equipment and materials to apply herbicide to any areas our customer needs.  Our application vehicles are able to reach any area service is needed – on road or off. Typical areas we provide service are sidewalk and curbing crack weeds, on bridge and barrier walls, along fence lines and behind guardrail.  Full documentation is provide each day including amount of herbicide applied, locations applied and wind speed.\n                        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(118)
    }
  })])])])])
}]}

/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title is-1"
  }, [_vm._v("Hydroseed Estimator")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Change the values for instantly recalculated results")]), _vm._v(" "), _c('div', {
    staticClass: "columns estimator"
  }, [_c('div', {
    staticClass: "column is-one-third-desktop"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Project & Equipment Details")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label dimension-label"
  }, [_vm._v("Total Project Size")]), _vm._v(" "), _c('div', {
    staticClass: "field has-addons"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.totalProjectSize),
      expression: "totalProjectSize",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": _vm.projectSizeUnit.name
    },
    domProps: {
      "value": (_vm.totalProjectSize)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.totalProjectSize = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    domProps: {
      "value": _vm.selectedProjectSizeUnit
    },
    on: {
      "change": function($event) {
        _vm.selectedProjectSizeUnit = $event.target.value
      }
    }
  }, _vm._l((_vm.projectSizeUnits), function(unit, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(unit.name))])
  }), 0)])])])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label dimension-label"
  }, [_vm._v("Working Capacity of Tank")]), _vm._v(" "), _c('div', {
    staticClass: "field has-addons"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.tankWorkingCapacity),
      expression: "tankWorkingCapacity",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "Tank size in gallons"
    },
    domProps: {
      "value": (_vm.tankWorkingCapacity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tankWorkingCapacity = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-light is-disabled",
    attrs: {
      "disabled": true
    }
  }, [_vm._v("gallons")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-third-desktop"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Mulch Application Details")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label dimension-label"
  }, [_vm._v("Target Application Rate")]), _vm._v(" "), _c('div', {
    staticClass: "field has-addons"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.mulchApplicationRate),
      expression: "mulchApplicationRate",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "Pounds of mulch per acre"
    },
    domProps: {
      "value": (_vm.mulchApplicationRate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mulchApplicationRate = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-light is-disabled",
    attrs: {
      "disabled": true
    }
  }, [_vm._v("lbs/acre")])])])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label dimension-label"
  }, [_vm._v("Weight of Mulch (per bag)")]), _vm._v(" "), _c('div', {
    staticClass: "field has-addons"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.mulchBagWeight),
      expression: "mulchBagWeight",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "Weight per bag of mulch"
    },
    domProps: {
      "value": (_vm.mulchBagWeight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mulchBagWeight = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-light is-disabled",
    attrs: {
      "disabled": true
    }
  }, [_vm._v("lbs")])])])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label dimension-label"
  }, [_vm._v("Mulch Mixing Rate")]), _vm._v(" "), _c('div', {
    staticClass: "field has-addons"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.mulchMixRate),
      expression: "mulchMixRate",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "Pounds of mulch per 100 gallons"
    },
    domProps: {
      "value": (_vm.mulchMixRate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mulchMixRate = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-light is-disabled",
    attrs: {
      "disabled": true
    }
  }, [_vm._v("lbs/100 gal")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-third-desktop"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Seed Application Details")]), _vm._v(" "), _vm._l((_vm.seeds), function(seed, index) {
    return (_vm.seeds.length > 0) ? _c('div', [_c('div', [_c('div', {
      staticClass: "field has-addons"
    }, [_c('p', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.seeds[index].name),
        expression: "seeds[index].name"
      }],
      staticClass: "input label-input",
      attrs: {
        "type": "text",
        "placeholder": "Seed Name"
      },
      domProps: {
        "value": (_vm.seeds[index].name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.seeds[index], "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('button', {
      staticClass: "button is-danger",
      on: {
        "click": function($event) {
          return _vm.removeSeed(index)
        }
      }
    }, [_vm._v("delete")])])])]), _vm._v(" "), _c('div', [_c('label', {
      staticClass: "label dimension-label"
    }, [_vm._v("Target Application Rate")]), _vm._v(" "), _c('div', {
      staticClass: "field has-addons"
    }, [_c('p', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.seeds[index].applicationRate),
        expression: "seeds[index].applicationRate",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "input",
      attrs: {
        "type": "number",
        "placeholder": "Pounds of seed per acre"
      },
      domProps: {
        "value": (_vm.seeds[index].applicationRate)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.seeds[index], "applicationRate", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('button', {
      staticClass: "button is-light is-disabled",
      attrs: {
        "disabled": true
      }
    }, [_vm._v("lbs/acre")])])])]), _vm._v(" "), _c('div', [_c('label', {
      staticClass: "label dimension-label"
    }, [_vm._v("Weight of Seed (per bag)")]), _vm._v(" "), _c('div', {
      staticClass: "field has-addons"
    }, [_c('p', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.seeds[index].bagWeight),
        expression: "seeds[index].bagWeight",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "input",
      attrs: {
        "type": "number",
        "placeholder": "Weight per bag of seed"
      },
      domProps: {
        "value": (_vm.seeds[index].bagWeight)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.seeds[index], "bagWeight", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('button', {
      staticClass: "button is-light is-disabled",
      attrs: {
        "disabled": true
      }
    }, [_vm._v("lbs")])])])]), _vm._v(" "), _c('div', [_c('label', {
      staticClass: "label dimension-label"
    }, [_vm._v("Seed Mixing Rate")]), _vm._v(" "), _c('div', {
      staticClass: "field has-addons"
    }, [_c('p', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.seeds[index].mixRate),
        expression: "seeds[index].mixRate",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "input",
      attrs: {
        "type": "number",
        "placeholder": "Pounds of seed per 100 gallons"
      },
      domProps: {
        "value": (_vm.seeds[index].mixRate)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.seeds[index], "mixRate", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('button', {
      staticClass: "button is-light is-disabled",
      attrs: {
        "disabled": true
      }
    }, [_vm._v("lbs/100 gal")])])])]), _vm._v(" "), (_vm.seeds.length > 1 && index !== _vm.seeds.length - 1) ? _c('hr') : _vm._e()]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.addSeed()
      }
    }
  }, [_vm._v("Add seed type")])])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "columns estimator"
  }, [_c('div', {
    staticClass: "column is-full"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Hydro Estimate:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "is-large results"
  }, [_vm._v("\n                    Your project has an area of "), _c('strong', [_vm._v(_vm._s(_vm.results.area))]), _vm._v(" square feet.\n                ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "service-title title is-1"
  }, [_vm._v("Tree Relocation")]), _vm._v(" "), _c('affix', {
    scopedSlots: _vm._u([{
      key: "navigation",
      fn: function(props) {
        return [_c('div', {
          ref: "subnav",
          class: {
            'service-navigation': true, 'has-affix': _vm.affixed
          }
        }, [_c('nav', {
          class: {
            'subnav-affix': _vm.affixed
          }
        }, [_c('ul', [_c('li', {
          class: {
            'is-active has-active': props.activeTrigger === 'why-a-tree-spade'
          }
        }, [_c('a', {
          attrs: {
            "href": "#why-a-tree-spade"
          }
        }, [_vm._v("Why a Tree Spade")])]), _vm._v(" "), _c('li', {
          class: {
            'is-active has-active': props.activeTrigger === 'the-process',
              'has-active': ['digging-the-hole', 'digging-the-tree', 'planting-the-tree'].indexOf(props.activeTrigger) !== -1,
          }
        }, [_c('a', {
          attrs: {
            "href": "#the-process"
          }
        }, [_vm._v("The Process")]), _vm._v(" "), _c('ul', {
          staticClass: "subnav"
        }, [_c('li', {
          class: {
            'is-active': props.activeTrigger === 'digging-the-hole'
          }
        }, [_c('a', {
          attrs: {
            "href": "#digging-the-hole"
          }
        }, [_vm._v("Digging the Hole")])]), _vm._v(" "), _c('li', {
          class: {
            'is-active': props.activeTrigger === 'digging-the-tree'
          }
        }, [_c('a', {
          attrs: {
            "href": "#digging-the-tree"
          }
        }, [_vm._v("Digging the Tree")])]), _vm._v(" "), _c('li', {
          class: {
            'is-active': props.activeTrigger === 'planting-the-tree'
          }
        }, [_c('a', {
          attrs: {
            "href": "#planting-the-tree"
          }
        }, [_vm._v("Planting the Tree")])])])]), _vm._v(" "), _c('li', {
          class: {
            'is-active has-active': props.activeTrigger === 'site-considerations',
              'has-active': ['design', 'soil-type', 'planting-depth'].indexOf(props.activeTrigger) !== -1,
          }
        }, [_c('a', {
          attrs: {
            "href": "#site-considerations"
          }
        }, [_vm._v("Site Considerations")]), _vm._v(" "), _c('ul', {
          staticClass: "subnav"
        }, [_c('li', {
          class: {
            'is-active': props.activeTrigger === 'design'
          }
        }, [_c('a', {
          attrs: {
            "href": "#design"
          }
        }, [_vm._v("Design")])]), _vm._v(" "), _c('li', {
          class: {
            'is-active': props.activeTrigger === 'soil-type'
          }
        }, [_c('a', {
          attrs: {
            "href": "#soil-type"
          }
        }, [_vm._v("Soil Type")])]), _vm._v(" "), _c('li', {
          class: {
            'is-active': props.activeTrigger === 'planting-depth'
          }
        }, [_c('a', {
          attrs: {
            "href": "#planting-depth"
          }
        }, [_vm._v("Planting Depth")])])])]), _vm._v(" "), _c('li', {
          class: {
            'is-active has-active': props.activeTrigger === 'post-relocation-care'
          }
        }, [_c('a', {
          attrs: {
            "href": "#post-relocation-care"
          }
        }, [_vm._v("Post-Relocation Care")])])])])])]
      }
    }])
  }, [_vm._v(" "), _c('div', {
    staticClass: "service-content",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "page-section"
  }, [_c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "why-a-tree-spade"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Why a Tree Spade")]), _vm._v(" "), _c('p', [_vm._v("\n                    Tree spading is the optimal method for moving and transplanting large trees from one site to another.\n                    The following are some reasons for transplanting large trees vs. younger, smaller trees:\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_vm._v("To create a mature landscape quickly.")]), _vm._v(" "), _c('li', [_vm._v("To alter the design of a landscape.")]), _vm._v(" "), _c('li', [_vm._v("To create space for a new building addition.")]), _vm._v(" "), _c('li', [_vm._v("\n                            To prevent the loss of a tree due to building, roadway expansion or other construction.\n                        ")]), _vm._v(" "), _c('li', [_vm._v("A mature tree has outgrown its present location.")]), _vm._v(" "), _c('li', [_vm._v("To move a tree to a site better suited to its needs.")])])]), _vm._v(" "), _c('p', [_vm._v("\n                    Initially, transplanting a tree with a tree spade may be more costly than purchasing container\n                    stock or B&B (ball and burlap) trees. However, the tree spade may be the best option if a tree will otherwise be\n                    lost or if the value of the tree outweighs the moving costs. Spading also saves on labor,\n                    planting time, and years of maintenance on a juvenile tree.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Tree spades are used in various ways throughout the green industry. Commercial nurseries use\n                    tree spades to lift large, field-grown trees out of the soil, and wrap the root ball in burlap\n                    and twine (termed \"ball and burlap\" or B&B) for retail sale or compact storage. Landscape\n                    companies and arborists use spades to plant large trees that are nursery-grown or have been\n                    moved from elsewhere in the landscape. Landscape professionals use a tree spade to create an\n                    \"instant landscape\" by digging and transplanting large trees from one location to another.\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "the-process"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("The Process")]), _vm._v(" "), _c('p', [_vm._v("\n                    Transplanting a tree with a tree spade can be summarized into 3 major steps:\n                    digging the hole, digging the tree and planting the tree.\n                    Many considerations must be taken into account during this process in order to alleviate\n                    stress on the tree as it transitions into its new location. With our expert knowledge,\n                    your tree will retain its health and resume its growth in a short time.\n                ")]), _vm._v(" "), _c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "digging-the-hole"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Digging the hole")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8"
  }, [_c('p', [_vm._v("\n                            First, a hole must be dug to receive the new tree. The tree spade used to dig the hole\n                            must be the proper size for the tree that will be dug and transplanted - this will ensure\n                            that the hole can accommodate a root ball substantial enough to support the tree.\n                        ")]), _vm._v(" "), _c('p', [_vm._v("\n                            The operator controls the spade from the rear of the truck. Hydraulic supports provide\n                            a stable foundation and prevent the spade from tipping over (a root ball from a 90\"\n                            tree spade can weigh up to 12,000 pounds!). The blades of the spade are inserted into the\n                            soil and are closed to contain the soil ball. The soil ball is positioned for\n                            transport using the spade hydraulics, then lifted onto the truck and hauled away.\n                            The soil ball may be used later on to fill in the hole left over by the tree\n                            being transplanted.\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(127)
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "digging-the-tree"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Digging the tree")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8"
  }, [_c('p', [_vm._v("\n                            The same tree spade used to dig the hole is now used to dig the tree. Before backing the\n                            spade up to the tree, the frame and rear blades are opened to encircle the tree trunk.\n                            The blades are then positioned in a equidistant fashion on all sides of the trunk,\n                            while also taking into account the size of the root ball.\n                        ")]), _vm._v(" "), _c('p', [_vm._v("\n                            The frame and rear blades are then driven down hydraulically into the soil.\n                            Each of the blades is independently moved several inches at a time until they are all\n                            at their maximum depth. With the blades now closed, the tree is then lifted by its\n                            root ball from the surrounding soil, and positioned onto the truck for transport.\n                        ")]), _vm._v(" "), _c('p', [_vm._v("\n                            At this time, the operator may need to prune the roots, secure any tree limbs or palm\n                            fronds, and adjust the tree spade for safe transport. Depending on the species of the\n                            tree, the time of year, and the travel distance, a tarp may be used to cover the tree\n                            canopy to prevent damage to the tree during transport. For highway transport, a special\n                            \"dirt skirt\", made by "), _c('strong', [_vm._v("HILCO")]), _vm._v(", is used to cover the spades to prevent soil loss.\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(125)
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "planting-the-tree"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Planting the tree")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8"
  }, [_c('p', [_vm._v("\n                            The operator now positions the spade over the previously dug hole. Adjustments may be\n                            made at this time if the tree has not been growing straight. If possible, the tree\n                            will be oriented in the same direction as its original location. The tree will be\n                            planted roughly 2-3 inches higher than the original grade to allow for settling.\n                            If a tree is planted too shallow, the roots may be damaged by temperature fluctuations\n                            and a lack of soil moisture. Planting a tree too deeply will result in girdling problems\n                            later on, leading to the death of the tree.\n                        ")]), _vm._v(" "), _c('p', [_vm._v("\n                            The tree is now lowered into the ground and the blades are removed by hydraulically\n                            sliding them up and out. Once the tree spade is removed and the transplantation\n                            complete, a water basin will be created at the outer edge of the soil ball. This allows\n                            water to penetrate the soil ball and surrounding soil, while ensuring the root ball\n                            is watered slowly and thoroughly. If large air spaces are apparent between the soil ball\n                            and the surrounding soil, additional soil can be added during the initial watering to\n                            ensure good soil contact for the newly developing roots. The water basin should then be\n                            filled with an organic mulch, at a minimum depth of 3 inches, which will help the tree\n                            and root ball retain moisture.\n                        ")]), _vm._v(" "), _c('p', [_vm._v("\n                            Although staking trees moved with tree spades is normally not necessary,\n                            if they are used, the staking should be removed as soon as the tree is well-rooted.\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(126)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "site-considerations"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Site Considerations")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n                        Individuals involved should have a general understanding of the tree spading process,\n                        and be familiar with the sites where the tree spade will be operated.\n                    ")]), _vm._v(" "), _c('li', [_vm._v("\n                        There should be adequate access for the tree spade to the original site and the new site.\n                        Because the spade is in a fixed position, it is desirable to plan the move with access to\n                        the preferred side of the tree.\n                        Maintaining the same exposure is beneficial to tree establishment.\n                    ")]), _vm._v(" "), _c('li', [_vm._v("\n                        Locate existing power lines, underground septic systems, grade changes and note any\n                        restrictions they present.\n                    ")]), _vm._v(" "), _c('li', [_vm._v("\n                        There should be adequate space for the tree spade to operate safely. A 44-inch tree spade\n                        requires approximately six feet around the tree that is unobstructed.\n                        A 90-inch spade requires eight feet.\n                    ")]), _vm._v(" "), _c('li', [_vm._v("\n                        Current soil conditions should be relatively dry. If the soil is too wet,\n                        the heavy machinery will damage the soil structure.\n                        Turf should be protected with 10-12 inches of wood mulch or ¾” plywood.\n                    ")]), _vm._v(" "), _c('li', [_vm._v("\n                        When transplanting a large tree, it is important to duplicate the original conditions as\n                        closely as possible, therefore reducing stress on the tree. Soil type, planting depth,\n                        staking, watering and mulching are critical factors to the success of the transplant.\n                    ")])]), _vm._v(" "), _c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "design"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Design")]), _vm._v(" "), _c('p', [_vm._v("\n                    Proper placement of trees is important to the design and sustainability of the landscape.\n                    It is important to select a location where the tree will not grow to interfere with structures,\n                    power lines, roof lines, windows and other existing plants. The species of tree selected for a\n                    site will depend on space requirements, existing plants and structures, seasonal interest\n                    desired and the function the tree will serve in the landscape. Some common functions of trees\n                    in landscapes are:\n                ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n                        Trees may be used to soften the architectural lines of a building and transition the eye\n                        from the roofline to the soil.\n                    ")]), _vm._v(" "), _c('li', [_vm._v("Trees may be used in a design to create shade and reduce summer cooling costs.")]), _vm._v(" "), _c('li', [_vm._v("Trees may protect a building from winter winds and thus reduce heating costs.")]), _vm._v(" "), _c('li', [_vm._v("Trees may act as a backdrop to a landscape.")]), _vm._v(" "), _c('li', [_vm._v("Trees may provide screening or a ceiling over an outdoor space.")])]), _vm._v(" "), _c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "soil-type"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Soil Type")]), _vm._v(" "), _c('p', [_vm._v("\n                    If possible, the soil type of the new location should match the soil type, drainage and pH of\n                    the original site as closely as possible. For large projects with many trees to be moved and transplanted,\n                    a soil analysis is recommended to compare soil structure, porosity, and amendments required. Knowledge of\n                    theses factors may favor one source of trees over another. Using a tree spade may also cause glazing, the\n                    compaction of the soil in the newly-dug hole, which will affect the lateral movement of soil moisture and\n                    root penetration. This can be resolved by roughing up the sides of the hole and the plug using a shovel, rake or fork.\n                ")]), _vm._v(" "), _c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "planting-depth"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Planting Depth")]), _vm._v(" "), _c('p', [_vm._v("\n                    The root ball of the tree should be watered thoroughly prior to digging to keep the ball intact\n                    and reduce as much soil loss as possible during transport. To allow the tree to become adequately\n                    hydrated, the tree should be watered 1-2 days prior to moving the tree. When positioning the\n                    tree in the new hole, it should be placed 2-3″ higher than the original grade to allow for settling.\n                    If a tree is planted too shallow, the roots may be damaged by temperature fluctuations and lack\n                    of soil moisture. Planting a tree too deeply will result in girdling problems later.\n                    For more information:\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    The site for the transplanted tree is prepared by tilling the soil and raking it smooth.\n                    Planting trees in established lawns is also a common practice. All grass within the drip line\n                    of the tree should be removed and replaced with mulch. This will prevent nutrient and moisture\n                    competition as well as possible mower damage.\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "post-relocation-care"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Post-Relocation Care")]), _vm._v(" "), _c('p', [_vm._v("\n                    Transplanted trees normally experience a two year period of transitional adjustment.\n                    During that time the root system will regenerate and flourish MUCH FASTER,\n                    if you closely follow our Intensified Tree Care Program.\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Watering")]), _vm._v(" "), _c('ul', {
    staticClass: "numeric-list"
  }, [_c('li', [_vm._v("\n                        Hand water the root ball area heavily, but not often based upon the soil moisture\n                        content at a depth of 4\"-6\". Apply a hose to soak the total root ball area for several\n                        hours. This is in addition to the water your trees may or may not be receiving from an\n                        automated drip irrigation system. Trees require more water in late Spring, Summer and\n                        Fall. They also must be kept moist through the Winter months. Trees can drown in heavy\n                        clay soils that are slow to drain, therefore, always check the moisture level with in the\n                        root ball area of your trees frequently by probing the soil to a depth of 12\". It is best to\n                        heavily water, let the root ball dry out and then heavily water again.\n                    ")]), _vm._v(" "), _c('li', [_vm._v("\n                        Hand water the foliage (leaves and central stem) by spraying water over the entire\n                        upper crown. This should be done DAILY for one week following transplanting.\n                        Thereafter, we recommend spraying the crown area once weekly to remove soot and\n                        other pollutants. Trees readily absorb moisture.\n                    ")]), _vm._v(" "), _c('li', [_vm._v("\n                        Refilling the Temporary Irrigation Units (if supplied with your trees) Refill TWICE weekly.\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("Suggested interval: Monday and Thursday")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("4\" - 6\" caliper trees")]), _vm._v(" "), _c('td', [_vm._v("6 gallons per day")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("7\" - 10\" caliper trees")]), _vm._v(" "), _c('td', [_vm._v("16 gallons per day")])])])]), _vm._v(" "), _c('p', [_vm._v("\n                    Irrigation units, Tree Gators, are an extra cost accessory item,\n                    which may not have been included with the planting work you contracted with us.\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Mulches")]), _vm._v(" "), _c('p', [_vm._v("\n                    Maintain a thick layer of wood chips or commercial cypress or shredded pine bark (3\"-4\") on\n                    top of the root ball spreading from the stem to 12\" beyond the root ball edge.\n                    Mulch helps to conserve moisture, modify soil temperatures and reduce weed growth.\n                    Avoid planting flowers shrubbery and installing tree collars within the root ball area\n                    of your trees for at least two years following installation\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Fertilization")]), _vm._v(" "), _c('p', [_vm._v("Apply a balance fertilizer with trace minerals.")]), _vm._v(" "), _c('ul', {
    staticClass: "numeric-list"
  }, [_c('li', [_vm._v("\n                        Rapid-Go or Miracle-Gro General Purpose are good water soluble fertilizer compounds.\n                        Mix 2 teaspoons per gallon and apply 10 gallons of mixed solution to each\n                        tree every 2 weeks for the first year\n                    ")]), _vm._v(" "), _c('li', [_vm._v("\n                        A second fertilizing option is to apply a balance time-release fertilizer in granular or\n                        table form. Sierra Blend, Osmocote or Agriform are some of the common types.\n                        Application should be applied evenly around the top of the root ball every four months.\n                        Initial application of 3 Lbs. followed by 1 ½ Lbs. every six months for the first two years.\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Insect Control")]), _vm._v(" "), _c('p', [_vm._v("\n                    Apply a broad spectrum granular insecticide around the top of the root ball to discourage\n                    any pests such as Bark and Leaf Aphids, Spider Mites, caterpillars, beetles and ants.\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Herbicides")]), _vm._v(" "), _c('p', [_vm._v("\n                    Weed and Grass killers should not be used in the vicinity of transplanted trees and shrubs.\n                    Round Up may be safely used only if the tree has 3”-4” of mulch over the root ball\n                    and the spray will not contact the roots or foliage directly.\n                ")])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field"
  }, [(_vm.label) ? _c('label', {
    attrs: {
      "for": _vm.id
    },
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [(_vm.type === 'textarea') ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempValue),
      expression: "tempValue"
    }],
    ref: "input",
    class: {
      'textarea': true, 'is-danger': _vm.fieldErrors
    },
    attrs: {
      "id": _vm.id,
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.tempValue)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.tempValue = $event.target.value
      }, _vm.handleInput],
      "keydown": _vm.handleKeyDown,
      "blur": _vm.handleBlur,
      "focus": _vm.handleFocus
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type !== 'textarea') ? _c('input', {
    ref: "input",
    class: {
      'input': true, 'is-danger': _vm.fieldErrors
    },
    attrs: {
      "id": _vm.id,
      "name": _vm.name,
      "type": _vm.type,
      "placeholder": _vm.placeholder,
      "required": _vm.required,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.tempValue
    },
    on: {
      "input": _vm.handleInput,
      "keydown": _vm.handleKeyDown,
      "blur": _vm.handleBlur,
      "focus": _vm.handleFocus
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.fieldErrors) ? _c('ul', {
    staticClass: "help is-danger form-errors"
  }, _vm._l((_vm.fieldErrors), function(error) {
    return _c('li', [_vm._v(_vm._s(error))])
  }), 0) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title is-1"
  }, [_vm._v("Material Estimator")]), _vm._v(" "), _c('div', {
    staticClass: "columns estimator"
  }, [_c('div', {
    staticClass: "column is-half-tablet is-one-third-desktop"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Project Details")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Material Type")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    domProps: {
      "value": _vm.selectedMaterial
    },
    on: {
      "change": function($event) {
        _vm.selectedMaterial = $event.target.value
      }
    }
  }, _vm._l((_vm.materials), function(material, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(material.name))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Area Shape")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    domProps: {
      "value": _vm.selectedArea
    },
    on: {
      "change": function($event) {
        _vm.selectedArea = $event.target.value
      }
    }
  }, _vm._l((_vm.areas), function(area, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(area.name))])
  }), 0)])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Area Dimensions")]), _vm._v(" "), _vm._l((_vm.areaDimensions), function(dimension, index) {
    return _c('div', [_c('label', {
      staticClass: "label dimension-label"
    }, [_vm._v(_vm._s(dimension.name))]), _vm._v(" "), _c('div', {
      staticClass: "field has-addons"
    }, [_c('p', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.dimensions[index].value),
        expression: "dimensions[index].value"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "placeholder": dimension.name
      },
      domProps: {
        "value": (_vm.dimensions[index].value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.dimensions[index], "value", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('span', {
      staticClass: "select"
    }, [_c('select', {
      domProps: {
        "value": _vm.dimensions[index].unit
      },
      on: {
        "change": function($event) {
          _vm.dimensions[index].unit = $event.target.value
        }
      }
    }, _vm._l((_vm.units), function(unit, index) {
      return _c('option', {
        domProps: {
          "value": index
        }
      }, [_vm._v(_vm._s(unit.name))])
    }), 0)])])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.materials[_vm.selectedMaterial].name) + " Estimate:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "is-large results"
  }, [_vm._v("\n                    Your project has an area of "), _c('strong', [_vm._v(_vm._s(Math.round((_vm.results.area / 12 / 108) * _vm.precision) / _vm.precision))]), _vm._v(" square yards.\n                    "), _c('br'), _vm._v("\n                    You will need roughly\n                    "), _c('strong', [_vm._v(_vm._s(_vm.results.yards))]), _vm._v("\n                    cubic yards of " + _vm._s(_vm.materials[_vm.selectedMaterial].name) + ".\n                    "), _c('br'), _vm._v("\n                    This weighs about\n                    "), _c('strong', [_vm._v(_vm._s(Math.round((_vm.results.yards * _vm.materials[_vm.selectedMaterial].poundsPerYard / 2000) * _vm.precision) / _vm.precision))]), _vm._v(" tons\n                    (or "), _c('strong', [_vm._v(_vm._s(Math.round((_vm.results.yards * _vm.materials[_vm.selectedMaterial].poundsPerYard) * _vm.precision) / _vm.precision))]), _vm._v(" pounds).\n\n                    "), _c('div', {
    staticClass: "area-shape"
  }, [(_vm.selectedArea === 'rectangle') ? _c('img', {
    attrs: {
      "src": __webpack_require__(133)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedArea === 'rectangleborder') ? _c('img', {
    attrs: {
      "src": __webpack_require__(134)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedArea === 'circle') ? _c('img', {
    attrs: {
      "src": __webpack_require__(131)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedArea === 'triangle') ? _c('img', {
    attrs: {
      "src": __webpack_require__(135)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedArea === 'circleborder') ? _c('img', {
    attrs: {
      "src": __webpack_require__(132)
    }
  }) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("Material weight reference (per cubic yard)")]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('em', [_c('strong', [_vm._v("Please note:")]), _vm._v(" "), _c('br'), _vm._v("\n                    This is an estimate planning tool "), _c('u', [_vm._v("only")]), _vm._v("\n                    and the real world values required for your project may\n                    differ from the values determined here. Material weight can vary according to the batch, moisture conditions,\n                    and other variables not accounted for in this estimate. Always be sure to double check your measurements\n                    and err on the side of more material rather than less before starting your project.\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Bark Mulch *")]), _vm._v(" "), _c('td', [_vm._v("600-800 Lbs.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Cypress Mulch *")]), _vm._v(" "), _c('td', [_vm._v("600-800 Lbs.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Soil Mixes *")]), _vm._v(" "), _c('td', [_vm._v("1300-1650 Lbs.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Gravel *")]), _vm._v(" "), _c('td', [_vm._v("2500-2600 Lbs.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Decomposed Granite *")]), _vm._v(" "), _c('td', [_vm._v("2600 Lbs.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Sand *")]), _vm._v(" "), _c('td', [_vm._v("2800 Lbs.")])])])]), _vm._v(" "), _c('em', [_vm._v("* weight varies by moisture content and grain or chip size")])])])
}]}

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "service-title title is-1"
  }, [_vm._v("Erosion Control")]), _vm._v(" "), _c('affix', {
    scopedSlots: _vm._u([{
      key: "navigation",
      fn: function(props) {
        return [_c('div', {
          ref: "subnav",
          class: {
            'service-navigation': true, 'has-affix': _vm.affixed
          }
        }, [_c('nav', {
          class: {
            'subnav-affix': _vm.affixed
          }
        }, [_c('ul', [_c('li', {
          class: {
            'is-active': props.activeTrigger === 'hydroseeding',
              'has-active': ['hydroseeding', 'soil-preparation', 'watering'].indexOf(props.activeTrigger) !== -1
          }
        }, [_c('a', {
          attrs: {
            "href": "#hydroseeding"
          }
        }, [_vm._v("Hydroseeding")]), _vm._v(" "), _c('ul', {
          staticClass: "subnav"
        }, [_c('li', {
          class: {
            'is-active': props.activeTrigger === 'soil-preparation'
          }
        }, [_c('a', {
          attrs: {
            "href": "#soil-preparation"
          }
        }, [_vm._v("Soil Preparation")])]), _vm._v(" "), _c('li', {
          class: {
            'is-active': props.activeTrigger === 'watering'
          }
        }, [_c('a', {
          attrs: {
            "href": "#watering"
          }
        }, [_vm._v("Watering")])])])]), _vm._v(" "), _c('li', {
          class: {
            'is-active': props.activeTrigger === 'drillseeding',
              'has-active': ['drillseeding'].indexOf(props.activeTrigger) !== -1
          }
        }, [_c('a', {
          attrs: {
            "href": "#drillseeding"
          }
        }, [_vm._v("Drillseeding")])]), _vm._v(" "), _c('li', {
          class: {
            'is-active': props.activeTrigger === 'silt-fencing',
              'has-active': ['silt-fencing'].indexOf(props.activeTrigger) !== -1
          }
        }, [_c('a', {
          attrs: {
            "href": "#silt-fencing"
          }
        }, [_vm._v("Silt Fencing")])]), _vm._v(" "), _c('li', {
          class: {
            'is-active': props.activeTrigger === 'erosion-control-blankets',
              'has-active': ['erosion-control-blankets'].indexOf(props.activeTrigger) !== -1
          }
        }, [_c('a', {
          attrs: {
            "href": "#erosion-control-blankets"
          }
        }, [_vm._v("Erosion Control Blankets")])]), _vm._v(" "), _c('li', {
          class: {
            'is-active': props.activeTrigger === 'erosion-control-logs',
              'has-active': ['erosion-control-logs'].indexOf(props.activeTrigger) !== -1
          }
        }, [_c('a', {
          attrs: {
            "href": "#erosion-control-logs"
          }
        }, [_vm._v("Erosion Control Logs")])])])])])]
      }
    }])
  }, [_vm._v(" "), _c('div', {
    staticClass: "service-content",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "page-section"
  }, [_c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "hydroseeding"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Hydroseeding")]), _vm._v(" "), _c('h1', {
    staticClass: "subtitle"
  }, [_vm._v(" \\ hi-dro-seeding \\ (verb)")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8"
  }, [_c('p', [_vm._v("\n                            Hydro-what? What in the world is hydro seeding? You've probably seen it but didn't know what to call it.\n                            If you've ever seen what looks like fuzzy green paint along the side of a road or surrounding a new building, you've seen hydro seeding.\n                        ")]), _vm._v(" "), _c('p', [_vm._v("\n                            But what does it do? Hydro seed machines mix together seed, water, fertilizer,\n                            tackifier (glue), and green wood fiber mulch to create a slurry. The slurry is\n                            sprayed on the ground with a high pressure hose which helps it to reach all kinds\n                            of terrain, like slopes, that may be difficult to reach. When the slurry dries,\n                            it creates a crust over the ground, protecting the area from erosion.\n                            The crust protects the seeds from being washed away in the rain or eaten by birds.\n                        ")]), _vm._v(" "), _c('p', [_vm._v("\n                            Grass seed isn't the only type of seed that can be applied this way.\n                            Wildflowers can be hydro-seeded for a burst of color.\n                            Wildflower seed can be selected for full sun, shade, or part shade conditions.\n                            Wildflowers make a wonderful transition from a yard to a wooded area or in community areas of sub-divisions.\n                            They will self-seed, creating a display for years to come.\n                            Wildflowers are typically hydro seeded in the fall or early spring.\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(120)
    }
  })])]), _vm._v(" "), _c('p', [_vm._v("\n                    Hydro seeding is the fastest, most cost effective and highest quality method of\n                    seeding lawn, landscape and erosion control practices. The hydro seeding slurry is\n                    applied with pressure via hose or tower onto the soil to create the ideal\n                    environment for seed germination and turf development.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    The key to successful seed germination in keeping the ground well water until the\n                    seeds begin to sprout. Then maintain a consistent watering regime while the grass fills in.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Grass should start to grow within 7 days, and will be well established\n                    within 3-4 weeks depending on soil type and amount of topsoil on the project.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    The advantages of hydro seeding include faster germination, increased plant survival,\n                    and the ability to cover large, inaccessible areas. The cost is less than that of sod\n                    even over flat areas, and it’s a more viable option in areas that are too steep to apply sod.\n                    Seed applied in a hydro seed mix will generally show growth and develop turf faster than broadcast seed.\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "soil-preparation"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("Soil Preparation")]), _vm._v(" "), _c('p', [_vm._v("\n                    Soil preparation is important before hydroseeding, if quick results are needed.\n                    Take into consideration the soil type and PH levels, the contour of the land\n                    and moisture content needed for adequate germination.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Gulf Coast is able to prepare the finished ground via giant\n                    discing with or without cultivation. We have lime spreading units that\n                    will bring the soil PH levels to except able standards for quick and even growth.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Top soil can also be imported to sites where dead soil becomes a problem due to the excess depth in borrow pits.\n                    This can resolve problems towards the completion date of bare patches on finished slopes.\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "watering"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("Watering")]), _vm._v(" "), _c('p', [_vm._v("\n                    With hydroseedings’ ability to retain up to 10 times its weight in water, it’s definitely proved\n                    to be the best method for fast, healthy germination, high plant survival and protection\n                    of seeds with a moisture sealant. No other method of growing grass, whether sod or hand\n                    seeding, has the advantages of hydroseeding when it comes to water retention.\n                    In the hydroseeding mix, fiber mulch and tackifiers are used to anchor the mixture to\n                    slopes and help seal in moisture. The water is then slowly released, along with nutrients,\n                    to the root system to constantly replenish itself until the next rainfall. A hydroseeded\n                    ground starts growing grass from the root first, allowing the root system to go deep into\n                    the ground where moisture is at its greatest, making a very drought-tolerant lawn. On the\n                    contrary, when using sod, the ground has a difficult time establishing a root system making\n                    it weak in drought type conditions, and with hand seeding, the watering demands are\n                    twice as much as a hydroseeded lawn.\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "drillseeding"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Drillseeding")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8"
  }, [_c('p', [_vm._v("\n                            A seed drill is a device that sows the seeds for grass or crops by metering out the\n                            individual seeds, positioning them in the soil, and covering them to a certain average\n                            depth. The seed drill sows the seeds at equal distances and proper depth, ensuring that\n                            the seeds get covered with soil and are saved from being eaten by birds. Before the\n                            introduction of the seed drill, a common practice was to plant seeds by hand. Besides\n                            being wasteful, planting was usually imprecise and led to a poor distribution of seeds,\n                            leading to low productivity.\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(114)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "silt-fencing"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Silt Fencing")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8"
  }, [_c('p', [_vm._v("\n                            A silt fence, sometimes (misleadingly) called a \"filter fence,\" is a temporary sediment\n                            control device used on construction sites to protect water quality in nearby streams,\n                            rivers, lakes and seas from sediment (loose soil) in storm water  runoff.\n                            Silt fences are widely used on construction sites in North America and elsewhere,\n                            due to their low cost and simple design. However, their effectiveness in controlling\n                            sediment can be limited, due to problems with poor installation, proper placement,\n                            and/or inadequate maintenance.\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(124)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "erosion-control-blankets"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Erosion Control Blankets")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8"
  }, [_c('p', [_vm._v("\n                            Erosion Control Blankets are thick, fibrous blankets woven out of either natural\n                            materials (e.g. straw and coconut fiber), synthetic materials (e.g. polypropylene)\n                            or a mixture of natural and synthetic materials. These blankets are used primarily\n                            to slow water runoff, provide effective sediment and erosion control, and enhance\n                            re-vegetation. These blankets are commonly applied to channel and ditch linings,\n                            slopes, culvert inlets and outfalls, riverbanks, and levees. Erosion control blankets\n                            are classified as short term, long term, or permanent use, mostly based on whether\n                            vegetation is intended to replace or work in conjunction with the blankets.\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(116)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "erosion-control-logs"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Erosion Control Logs")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8"
  }, [_c('p', [_vm._v("\n                            Erosion Control Logs, commonly called wattles, are a very effective sediment control\n                            measure. Available in a variety of sizes: 9\", 12\" and 18\", additional diameters are\n                            available for more severe applications. Erosion Control Logs are contained by a\n                            photodegradable netting which is designed to last at least two construction seasons.\n                        ")]), _vm._v(" "), _c('p', [_vm._v("\n                            Erosion Control Logs, when properly installed, reduce the rate of water flow,\n                            absorbing water and filtering sediment. A significant amount of sediment will drop\n                            out of the water behind the log during a rain event. Fiber is weed free and naturally\n                            biodegradable, enhancing the soil and helping vegetation become established.\n                            On steep slopes, logs used in conjunction with a properly designed and installed\n                            erosion control blanket results in an effective BMP.\n                        ")]), _vm._v(" "), _c('p', [_vm._v("Advantages")]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_c('li', [_vm._v("Easy to transport and install.")]), _vm._v(" "), _c('li', [_vm._v("Low cost, a single person can usually construct up to 6 a day.")]), _vm._v(" "), _c('li', [_vm._v("A low cost solution to sheet and rill erosion problems.")]), _vm._v(" "), _c('li', [_vm._v("Flexible enough to conform to most applications.")]), _vm._v(" "), _c('li', [_vm._v("Effective at trapping sediment and slowing the velocity of the water.")]), _vm._v(" "), _c('li', [_vm._v("Helps establish and store moisture for native vegetation.")]), _vm._v(" "), _c('li', [_vm._v("\n                                Straw wattles are sterile and seedless, eliminating the introduction of non-native vegetation.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("\n                                Straw wattle will decompose over time allowing regrowth of native vegetation that will help to stabilize the site.\n                            ")]), _vm._v(" "), _c('li', [_vm._v("Plastic netting is photodegradable and straw becomes incorporated into soil.")])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(117)
    }
  })])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "service-title title is-1"
  }, [_vm._v("Irrigation Systems")]), _vm._v(" "), _c('affix', {
    scopedSlots: _vm._u([{
      key: "navigation",
      fn: function(props) {
        return [_c('div', {
          ref: "subnav",
          class: {
            'service-navigation': true, 'has-affix': _vm.affixed
          }
        }, [_c('nav', {
          class: {
            'subnav-affix': _vm.affixed
          }
        }, [_c('ul', [_c('li', {
          class: {
            'is-active has-active': props.activeTrigger === 'why'
          }
        }, [_c('a', {
          attrs: {
            "href": "#why"
          }
        }, [_vm._v("Importance of Irrigation")])]), _vm._v(" "), _c('li', {
          class: {
            'is-active has-active': props.activeTrigger === 'resource-usage'
          }
        }, [_c('a', {
          attrs: {
            "href": "#resource-usage"
          }
        }, [_vm._v("Resource Usage")])]), _vm._v(" "), _c('li', {
          class: {
            'is-active has-active': props.activeTrigger === 'drip-irrigation'
          }
        }, [_c('a', {
          attrs: {
            "href": "#drip-irrigation"
          }
        }, [_vm._v("Drip Irrigation")])])])])])]
      }
    }])
  }, [_vm._v(" "), _c('div', {
    staticClass: "service-content",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "why"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("The importance of irrigation")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('p', [_vm._v("\n                            Irrigation is the method in which a controlled amount of water is supplied to plants at regular intervals for agriculture.\n                            It is used to assist in the growing of agricultural crops, maintenance of landscapes,\n                            and revegetation of disturbed soils in dry areas and during periods of inadequate rainfall.\n                            These can be installed with rotary spray heads or with a drip system.\n                        ")]), _vm._v(" "), _c('p', [_vm._v("\n                            If you’re a business owner in the Rio Grande Valley, you know the importance of\n                            creating a good impression with your customers. Your lawn and landscaping can be a big part of\n                            that first impression. Whether you’re caring for a small space or a huge system of lawns and\n                            gardens, Gulf Coast’s commercial irrigation and sprinkler systems can create a lush,\n                            beautiful landscape for your business.\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(121)
    }
  })])]), _vm._v(" "), _c('p', [_vm._v("\n                    Commercial irrigation isn’t like home irrigation. Most businesses have special needs and\n                    challenges that make their projects unique. A professionally-installed commercial\n                    irrigation system ensures your landscape stays green and healthy no matter the challenge.\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "resource-usage"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Ensuring your resources are used right.")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-7"
  }, [_c('p', [_vm._v("\n                            Over-watering and under-watering aren’t just wasteful; they’re actually damaging to grass and\n                            plants. If your sprinkler and irrigation system can’t adjust to the rapidly changing\n                            South Texas weather, it could do more harm than good.\n                        ")]), _vm._v(" "), _c('p', [_vm._v("\n                            Some of the principal causes of damage from poor irrigation systems are:\n                        ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Watering the lawn even when it’s raining")]), _vm._v(" "), _c('li', [_vm._v("Watering during the wrong time of the day")]), _vm._v(" "), _c('li', [_vm._v("Over-watering past the saturation point of the soil")]), _vm._v(" "), _c('li', [_vm._v("No watering all grass or plants evenly")])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-5"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(122)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('a', {
    staticClass: "affix-trigger",
    attrs: {
      "name": "drip-irrigation"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Drip Irrigation Systems")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-7"
  }, [_c('p', [_vm._v("\n                            Traffic islands, for example, present unique challenges in terms of irrigation.\n                            Their unique narrow shapes and their vicinity to roads, requires extra precision to\n                            avoid vehicular and pedestrian damage. In addition, the variety of plants in such a small area,\n                            from grass to trees and flower beds, requires precise irrigation that can offer differential\n                            treatment to every type of plant.\n                        ")]), _vm._v(" "), _c('p', [_vm._v("\n                            Irrigation systems with (pop–ups) waste water and energy through evaporation and wind over spray,\n                            and they often create surface run-off. With drip irrigation, the water is applied directly to\n                            the plant’s root zone, optimizing water usage, eliminating run-off and enhancing its beauty.\n                            Gulf Coast’s drip irrigation solutions take it even further by implementing advanced technologies\n                            that ensure durability, lower maintenance and outstanding water and energy savings. Our product\n                            lines include a wide range of sub-surface and on-surface drippers and dripper lines\n                            designed for every need\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-5"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__(123)
    }
  })])]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("No run-offs and wind over sprays")]), _vm._v(" "), _c('dd', [_vm._v("\n                        Unlike overhead irrigation, which is subject to runoff and wind over spray,\n                        drip irrigation accurately applies water to the root zone only.\n                        This not only means saving water but better plant health as well.\n                    ")]), _vm._v(" "), _c('dt', [_vm._v("Eliminates vandalism")]), _vm._v(" "), _c('dd', [_vm._v("\n                        Since the systems are often completely buried and not visible, vandalism is avoided, reducing maintenance costs.\n                    ")]), _vm._v(" "), _c('dt', [_vm._v("Precise and flexible treatment for every type of plant")]), _vm._v(" "), _c('dd', [_vm._v("\n                        Unlike overhead irrigation, drip irrigation offers precise control and flexibility.\n                        Even in a small and narrow area, you can apply different irrigation policies for every type of plant.\n                        For example, flower beds can receive a different dosage of water and fertilizers, than the ones applied on grass or trees.\n                    ")]), _vm._v(" "), _c('dt', [_vm._v("Long laterals with a single valve")]), _vm._v(" "), _c('dd', [_vm._v("\n                        Gulf Coast’s drip irrigation solutions are both low pressure and low flow systems.\n                        This means that you can deploy very long laterals connected to a single valve and still\n                        enjoy uniform irrigation throughout the traffic island. In contrast, overhead irrigation\n                        requires splitting the traffic islands into irrigation zones which are connected to\n                        multiple water sources, wasting more water and energy and requiring more ongoing maintenance.\n                    ")]), _vm._v(" "), _c('dt', [_vm._v("Self-cleaning and root prevention")]), _vm._v(" "), _c('dd', [_vm._v("\n                        Gulf Coast’s drip irrigation solutions were designed to operate in the toughest environments\n                        (even below the ground) without requiring any maintenance or intervention. A combination\n                        of unique technologies ensure that the dripper withstands dirt clogging and intrusion of roots.\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    At Gulf Coast, we install commercial sprinklers and irrigation systems in the Rio Grande Valley\n                    that include automatic rain shut-off sensors, soil moisture monitors, and drip irrigation\n                    systems for gardens and flower beds. These systems are scalable to suit any business,\n                    and they ensure your landscape stays healthy and your water bill stays under control.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Don’t waste money on inadequate systems. Call Gulf Coast today and get the commercial\n                    irrigation systems your Rio Grande Valley business needs.\n                ")])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "svg-render"
  }, [(_vm.file === 'header') ? _c('svg', {
    staticClass: "svg-block",
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "1400px",
      "height": "400px",
      "viewBox": "0 0 1400 400",
      "enable-background": "new 0 0 1400 400",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "stroke-width": "18",
      "stroke-miterlimit": "10",
      "d": "M645.205,192.951h104.497l0.695,47.12\n                c0,34.313-6.463,56.422-19.387,66.332c-12.926,9.91-41.759,14.867-86.501,14.867c-41.034,0-68.218-6.607-81.546-19.822\n                c-13.331-13.215-19.996-40.164-19.996-80.852c0-51.927,2.665-84.732,7.998-98.411c6.607-16.692,16.632-27.934,30.08-33.731\n                c13.445-5.795,36.279-8.693,68.506-8.693c42.191,0,69.433,4.493,81.72,13.475c12.285,8.984,18.431,28.893,18.431,59.725h-45.555\n                c-0.812-15.532-4.202-25.182-10.171-28.95c-5.972-3.766-20.952-5.651-44.946-5.651c-26.081,0-42.629,3.247-49.641,9.737\n                c-7.015,6.493-10.52,21.734-10.52,45.729l-0.174,23.82l0.348,30.427c0,23.533,3.478,38.514,10.433,44.947\n                s23.065,9.648,48.337,9.648c24.572,0,40.191-2.721,46.858-8.172c6.664-5.447,9.997-18.313,9.997-38.6l0.175-9.736h-59.639V192.951z\n                "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "stroke-width": "18",
      "stroke-miterlimit": "10",
      "d": "M946.421,234.506h45.207v8.172\n                c0,33.037-6.029,54.395-18.083,64.072c-12.057,9.68-38.717,14.52-79.981,14.52c-46.831,0-75.635-7.65-86.415-22.951\n                c-10.779-15.301-16.17-56.219-16.17-122.755c0-39.179,7.303-64.941,21.908-77.287c14.605-12.345,45.147-18.517,91.631-18.517\n                c33.846,0,56.448,5.072,67.811,15.214c11.358,10.144,17.039,30.284,17.039,60.42l0.174,5.39h-45.207v-6.085\n                c0-15.532-2.929-25.472-8.78-29.819c-5.854-4.347-19.213-6.52-40.078-6.52c-27.936,0-44.715,3.42-50.336,10.258\n                c-5.623,6.841-8.433,27.124-8.433,60.855c0,45.441,2.521,72.332,7.563,80.677s21.356,12.518,48.945,12.518\n                c22.37,0,36.888-2.316,43.555-6.953c6.664-4.635,9.998-14.838,9.998-30.602L946.421,234.506z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "stroke-width": "18",
      "stroke-miterlimit": "10",
      "d": "M1184.349,234.506h45.207v8.172\n                c0,33.037-6.029,54.395-18.083,64.072c-12.057,9.68-38.717,14.52-79.981,14.52c-46.831,0-75.635-7.65-86.415-22.951\n                c-10.779-15.301-16.17-56.219-16.17-122.755c0-39.179,7.303-64.941,21.908-77.287c14.605-12.345,45.147-18.517,91.631-18.517\n                c33.846,0,56.448,5.072,67.811,15.214c11.358,10.144,17.039,30.284,17.039,60.42l0.174,5.39h-45.207v-6.085\n                c0-15.532-2.929-25.472-8.78-29.819c-5.854-4.347-19.213-6.52-40.078-6.52c-27.936,0-44.715,3.42-50.336,10.258\n                c-5.623,6.841-8.433,27.124-8.433,60.855c0,45.441,2.521,72.332,7.563,80.677s21.356,12.518,48.945,12.518\n                c22.37,0,36.888-2.316,43.555-6.953c6.664-4.635,9.998-14.838,9.998-30.602L1184.349,234.506z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "stroke-width": "18",
      "stroke-miterlimit": "10",
      "d": "M1320.734,81.846v237.335h-45.033V81.846\n                H1320.734z"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "fill": "#39750B",
      "d": "M266.053,167.85c-0.016,4.405-0.357,211.065-0.432,216.681\n            c-0.112,8.509-21.694-25.394-22.717-28.951c-3.542-12.325-0.416-174.43-0.416-186.123c0-1.681-0.481-12.717,4.568-13.151\n            C251.452,155.928,266.073,162.459,266.053,167.85z M387.872,217.93c-0.78,3.333-32.126-31.573-38.202-37.65\n            c-2.579-3.866,5.261-9.223,5.536-13.841c0.425-7.129,1.661-18.825,4.43-17.441C365.77,152.065,395.899,183.602,387.872,217.93z\n             M84.856,157.18c1.66,7.061-20.971,14.95-39.172,32.187c-15.201,14.398-29.97,27.56-27.062,4.771\n            c1.828-14.33,9.294-27.887,17.9-39.146c4.659-6.095,9.794-13.595,16.395-17.776c8.477-5.367,11.756-1.385,17.985,4.427\n            C70.902,141.643,82.938,149.031,84.856,157.18z M224.302,121.564c4.152,5.536,4.259,11.17-9.05,26.897\n            c-13.31,15.726-32.784,19.365-38.332,21.538c-5.546,2.173,5.954-29.912,19.166-40.993\n            C201.678,123.414,220.149,116.027,224.302,121.564z M317.944,122.11c15.125,5.401,30.425,14.406,23.533,31.637\n            c-0.857,2.571-3.607,12.606-6.603,12.127c-1.904-0.305-13.941-8.525-18.012-10.852c-9.551-5.457-18.93-9.422-29.238-13.08\n            c-7.48-2.655-11.253-8.024-11.253-15.576c0-6.061,7.273-11.092,12.708-11.504C299.033,114.107,308.882,118.603,317.944,122.11\n            C321.605,123.417,309.839,118.971,317.944,122.11z M212.31,96.022c23.811,1.041,24.641,3.949,11.911,8.637\n            c-17.522,6.455-58.022,11.452-112.469,40.365c-18.969,10.074-12.816-2.656-17.44-6.021c-4.873-3.547-21.801-13.497-20.348-16.611\n            c3.964-8.494,45.044-22.017,70.025-24.235C171.03,95.756,193.124,95.183,212.31,96.022z M455.194,115.135\n            c26.367,30.488,31.804,81.726,28.058,78.929c-3.236-2.416-59.424-63.201-98.098-74.775c-8.402-2.515-0.318-14.25,0.277-19.656\n            s0.952-12.145,3.322-16.886C393.723,81.616,428.618,84.407,455.194,115.135z M264.082,90.27c0.604,16.064,1.282,25.483,1.528,39.728\n            c0.083,4.787,2.347,19.249-2.39,19.084c-3.151-0.11-6.008-3.536-9.188-2.395c-4.331,1.554-10.631,4.176-11.129-2.009\n            c-0.968-12.042-0.085-28.208,0.135-37.82c0.146-6.294-0.88-13.833,1.188-19.885C247.953,76.068,263.638,78.437,264.082,90.27z\n             M362.496,111.458c-6.389,2.13-79.022-5.283-80.453-15.904c-1.43-10.624,81.007-21.191,86.821-17.039\n            c3.184,2.273-1.987,9.32-3.557,15.236C363.541,100.409,365.879,110.331,362.496,111.458z M67.623,86.898\n            c2.491,2.215,9.851,6.831,8.859,10.521c-0.993,3.688-15.057,8.904-30.559,21.361c-15.503,12.458-31.038,28.469-36.437,31.375\n            c-5.398,2.907,2.493-36.957,19.103-53.845C45.2,79.424,59.042,71.119,61.256,75.271C63.471,79.424,65.132,84.683,67.623,86.898z\n             M232.443,82.687c-14.593-2.235-50.462-3.138-69.474-3.138c-19.816,0-42.244,3.817-61.183,9.417\n            c-8.714,2.576-13.416-0.706-19.099-7.605c-3.321-4.035-13.816-11.044-7.577-15.952c12.464-9.801,49.1-15.27,75.053-16.1\n            C176.117,48.479,222.002,65.504,232.443,82.687z M490.833,123.947c-6.282-0.965-35.433-32.839-50.629-42.555\n            c-14.169-9.057-30.147-16.724-46.87-18.691c-14.119-1.66-10.569-8.382-6.367-12.734c3.423-3.546-1.938-19.102,6.792-18.075\n            c5.468,0.643,33.083,8.093,56.89,24.98C474.457,73.759,497.113,124.911,490.833,123.947z M370.763,29.869\n            c8.641,1.571,0.646,14.633-0.785,17.78c-4.456,9.655,1.11,11.8-13.018,12.456c-25.192,1.171-75.235,22.999-85.954,8.625\n            C261.266,55.669,347.739,28.269,370.763,29.869C373.679,30.072,369.193,29.608,370.763,29.869z M246.897,64.776\n            c-11.051,0.208-19.356-16.61-33.682-24.5c-9.494-5.229-35.919-14.119-35.919-17.025c0-2.907,49.84-21.157,65.609,6.229\n            C251.104,43.718,248.778,64.741,246.897,64.776z"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.file === 'footer') ? _c('svg', {
    staticClass: "svg-block",
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "250px",
      "height": "300px",
      "viewBox": "0 0 250 300",
      "enable-background": "new 0 0 250 300",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "stroke-width": "5",
      "stroke-miterlimit": "10",
      "d": "M43.902,236.412h28.391l0.189,12.803\n                c0,9.322-1.756,15.328-5.267,18.021c-3.512,2.693-11.346,4.039-23.501,4.039c-11.148,0-18.534-1.795-22.155-5.385\n                c-3.622-3.59-5.433-10.912-5.433-21.967c0-14.107,0.724-23.021,2.173-26.737c1.795-4.534,4.519-7.589,8.172-9.164\n                c3.653-1.574,9.856-2.362,18.612-2.362c11.463,0,18.864,1.221,22.203,3.661c3.337,2.44,5.007,7.851,5.007,16.228H59.916\n                c-0.221-4.221-1.142-6.842-2.763-7.866c-1.623-1.022-5.692-1.535-12.211-1.535c-7.086,0-11.582,0.882-13.487,2.646\n                c-1.906,1.764-2.858,5.904-2.858,12.424l-0.047,6.471l0.095,8.268c0,6.395,0.945,10.463,2.834,12.211\n                c1.889,1.748,6.267,2.623,13.132,2.623c6.676,0,10.919-0.74,12.731-2.221c1.811-1.48,2.716-4.977,2.716-10.488l0.047-2.645H43.902\n                V236.412z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "stroke-width": "5",
      "stroke-miterlimit": "10",
      "d": "M125.739,247.703h12.282v2.221\n                c0,8.975-1.638,14.777-4.913,17.406c-3.276,2.631-10.519,3.945-21.73,3.945c-12.724,0-20.549-2.078-23.478-6.236\n                c-2.929-4.156-4.394-15.273-4.394-33.35c0-10.645,1.984-17.645,5.952-20.998c3.968-3.354,12.266-5.031,24.895-5.031\n                c9.195,0,15.336,1.379,18.423,4.134c3.086,2.756,4.629,8.228,4.629,16.415l0.047,1.465h-12.282v-1.654\n                c0-4.219-0.796-6.92-2.386-8.101c-1.59-1.181-5.22-1.771-10.889-1.771c-7.59,0-12.148,0.929-13.675,2.787\n                c-1.528,1.858-2.292,7.37-2.292,16.534c0,12.346,0.685,19.65,2.055,21.918s5.802,3.402,13.298,3.402\n                c6.078,0,10.022-0.631,11.833-1.891c1.811-1.26,2.716-4.031,2.716-8.314L125.739,247.703z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "stroke-width": "5",
      "stroke-miterlimit": "10",
      "d": "M190.38,247.703h12.282v2.221\n                c0,8.975-1.638,14.777-4.913,17.406c-3.276,2.631-10.519,3.945-21.73,3.945c-12.724,0-20.549-2.078-23.478-6.236\n                c-2.929-4.156-4.394-15.273-4.394-33.35c0-10.645,1.984-17.645,5.952-20.998c3.968-3.354,12.266-5.031,24.895-5.031\n                c9.195,0,15.336,1.379,18.423,4.134c3.086,2.756,4.629,8.228,4.629,16.415l0.047,1.465h-12.282v-1.654\n                c0-4.219-0.796-6.92-2.386-8.101c-1.59-1.181-5.22-1.771-10.889-1.771c-7.59,0-12.148,0.929-13.675,2.787\n                c-1.528,1.858-2.292,7.37-2.292,16.534c0,12.346,0.685,19.65,2.055,21.918s5.802,3.402,13.298,3.402\n                c6.078,0,10.022-0.631,11.833-1.891c1.811-1.26,2.716-4.031,2.716-8.314L190.38,247.703z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "stroke-width": "5",
      "stroke-miterlimit": "10",
      "d": "M227.434,206.228v64.481h-12.235v-64.481\n                H227.434z"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M130.159,90.691c-0.007,1.937-0.157,92.824-0.19,95.294\n            c-0.049,3.742-9.541-11.167-9.991-12.732c-1.558-5.421-0.183-76.712-0.183-81.855c0-0.739-0.211-5.593,2.009-5.783\n            C123.737,85.448,130.167,88.32,130.159,90.691z M183.733,112.715c-0.343,1.466-14.129-13.886-16.801-16.558\n            c-1.134-1.7,2.313-4.056,2.435-6.087c0.187-3.135,0.73-8.279,1.948-7.67C174.013,83.749,187.264,97.618,183.733,112.715z\n             M50.47,85.998c0.73,3.105-9.223,6.575-17.228,14.156c-6.686,6.332-13.181,12.121-11.901,2.098\n            c0.804-6.302,4.087-12.265,7.872-17.216c2.049-2.681,4.307-5.979,7.21-7.818c3.728-2.36,5.17-0.609,7.91,1.947\n            C44.333,79.165,49.626,82.415,50.47,85.998z M111.797,70.335c1.826,2.435,1.873,4.912-3.98,11.829\n            c-5.854,6.916-14.418,8.516-16.858,9.472c-2.439,0.956,2.619-13.155,8.429-18.028C101.847,71.148,109.971,67.9,111.797,70.335z\n             M152.98,70.575c6.652,2.375,13.38,6.336,10.35,13.914c-0.377,1.13-1.586,5.544-2.904,5.333c-0.837-0.134-6.131-3.749-7.921-4.772\n            c-4.201-2.4-8.325-4.144-12.859-5.752c-3.29-1.167-4.949-3.529-4.949-6.85c0-2.666,3.198-4.878,5.589-5.06\n            C144.663,67.055,148.995,69.032,152.98,70.575C154.59,71.15,149.416,69.194,152.98,70.575z M106.523,59.102\n            c10.472,0.458,10.837,1.736,5.238,3.798c-7.707,2.839-25.518,5.037-49.463,17.752c-8.342,4.431-5.637-1.168-7.67-2.648\n            c-2.143-1.56-9.588-5.936-8.949-7.305c1.743-3.736,19.81-9.683,30.796-10.659C88.368,58.984,98.085,58.732,106.523,59.102z\n             M213.341,67.507c11.596,13.408,13.987,35.942,12.34,34.712c-1.423-1.062-26.134-27.795-43.143-32.886\n            c-3.695-1.106-0.14-6.267,0.122-8.644c0.262-2.377,0.419-5.341,1.461-7.427C186.307,52.766,201.653,53.993,213.341,67.507z\n             M129.292,56.572c0.266,7.064,0.564,11.207,0.672,17.472c0.036,2.105,1.032,8.465-1.051,8.393c-1.386-0.048-2.642-1.555-4.041-1.053\n            c-1.905,0.684-4.676,1.837-4.895-0.883c-0.426-5.296-0.038-12.405,0.059-16.633c0.064-2.768-0.387-6.083,0.522-8.745\n            C122.198,50.326,129.096,51.368,129.292,56.572z M172.573,65.89c-2.81,0.937-34.753-2.323-35.382-6.995\n            c-0.629-4.672,35.626-9.319,38.183-7.493c1.4,1-0.874,4.099-1.564,6.701C173.033,61.031,174.061,65.394,172.573,65.89z\n             M42.891,55.089c1.096,0.974,4.333,3.004,3.896,4.627c-0.437,1.622-6.622,3.916-13.439,9.395s-13.65,12.52-16.024,13.798\n            c-2.374,1.278,1.096-16.253,8.401-23.681c7.306-7.426,13.393-11.079,14.367-9.253C41.064,51.802,41.795,54.115,42.891,55.089z\n             M115.377,53.237c-6.418-0.983-22.193-1.38-30.554-1.38c-8.715,0-18.579,1.679-26.908,4.142c-3.833,1.133-5.9-0.311-8.399-3.345\n            c-1.461-1.774-6.077-4.857-3.333-7.016c5.481-4.31,21.594-6.715,33.008-7.081S110.786,45.68,115.377,53.237z M229.015,71.383\n            c-2.763-0.425-15.583-14.442-22.266-18.716c-6.231-3.983-13.258-7.355-20.613-8.22c-6.209-0.73-4.648-3.686-2.8-5.6\n            c1.506-1.56-0.852-8.401,2.987-7.949c2.405,0.282,14.549,3.559,25.02,10.986C221.813,49.311,231.777,71.807,229.015,71.383z\n             M176.209,30.008c3.8,0.691,0.284,6.436-0.345,7.82c-1.96,4.246,0.488,5.189-5.725,5.478c-11.079,0.515-33.088,10.115-37.802,3.793\n            C128.053,41.354,166.083,29.304,176.209,30.008C177.492,30.097,175.519,29.894,176.209,30.008z M121.734,45.36\n            c-4.86,0.091-8.513-7.305-14.813-10.775c-4.175-2.299-15.797-6.209-15.797-7.488c0-1.278,21.919-9.304,28.854,2.739\n            C123.584,36.099,122.562,45.344,121.734,45.36z"
    }
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ })
]),[73]);


// WEBPACK FOOTER //
// static/js/app.660388e1ad589fc18308.js